// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  overflow-x: hidden;
}

.dashbored-wrap {
  width: 100%;
  height: 100vh;
  background: var(--fc-bg, #fff);
  /* Ensure cards show icon left, count/title right */
  /* Remove gray background behind icon/count for dashboard cards */
  /* Mobile view - Blue View Analytics text */
  /* prevent hover effect for empty row */
  /* Flow Reviews–style filters/search bar */
}
.dashbored-wrap .logo {
  width: 100px;
  margin-right: 100px;
}
.dashbored-wrap .top-menu-wrap {
  display: flex;
  align-items: center;
  padding: 20px 10px;
}
.dashbored-wrap .user-name {
  display: flex;
  align-items: center;
}
.dashbored-wrap .user-details {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
.dashbored-wrap .user-name p {
  display: flex;
  align-items: center;
}
.dashbored-wrap .user-name span {
  width: 40px;
  height: 40px;
  background: red;
  border-radius: 50%;
  display: block;
  margin-right: 10px;
}
.dashbored-wrap .top-menu-wrap {
  width: 100%;
  height: 100px;
  background: #fff;
}
.dashbored-wrap .dash-details {
  width: 100%;
  display: flex;
  max-height: 100vh;
  /* background: green; */
}
.dashbored-wrap .detail-list {
  max-width: 250px;
  width: 100%;
  padding: 20px 10px;
  background-color: #efeeee;
  color: #212529;
  position: fixed;
  top: calc(var(--app-header) + 5px);
  height: calc(100vh - 120px);
}
.dashbored-wrap ul {
  list-style: none;
  padding: 0px;
  margin: 0px;
}
.dashbored-wrap p {
  margin-bottom: 10px;
}
.dashbored-wrap ul li {
  margin-bottom: 10px;
  height: 40px;
  padding: 0px 10px;
  position: relative;
  z-index: 1;
  color: #212529;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
}
.dashbored-wrap ul li:before {
  bottom: 0;
  content: "";
  display: block;
  height: 100%;
  left: 0px;
  position: absolute;
  background: #fff;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
  width: 0%;
  z-index: -1;
}
.dashbored-wrap ul li:hover {
  color: #000;
}
.dashbored-wrap ul li:hover:before {
  /* background: #fff;
  color: #212529; */
  width: 100%;
}
.dashbored-wrap .table-bordered {
  border: 0px;
}
.dashbored-wrap .detail-description {
  width: 100%;
  height: 100%;
  padding: 0px;
  position: absolute;
  /* background: purple; */
}
.dashbored-wrap .followers-tag {
  display: flex;
  position: relative;
  z-index: 1;
  width: 100%;
  flex-wrap: wrap;
  gap: 16px;
}
.dashbored-wrap .stats-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
  margin-bottom: 32px; /* extra space to prevent overlap with table at mid zooms */
}
.dashbored-wrap .stats-cards .box {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  box-shadow: none;
  background-color: #fff;
  margin-top: 0; /* ensure cards appear right after the header */
}
.dashbored-wrap .stats-cards .box .ico-box {
  background: transparent;
  border-radius: 0;
}
.dashbored-wrap .stats-cards .box .ico-box .card-icon {
  color: #5ea1d8;
}
.dashbored-wrap .stats-cards .box .icon {
  flex: 0 0 auto;
}
.dashbored-wrap .stats-cards .box .text {
  display: flex;
  flex-direction: column;
}
.dashbored-wrap .cards-grid .box .text .count {
  background: transparent !important;
  box-shadow: none !important;
}
.dashbored-wrap .cards-grid .box .text .count b {
  font-size: 24px;
  font-weight: 400 !important;
}
.dashbored-wrap h3 {
  position: relative;
  z-index: 3;
  color: #fff;
  font-weight: normal;
}
.dashbored-wrap .com-record {
  width: calc(100% - 250px);
  width: 100%;
  height: auto;
  position: relative;
  z-index: 0;
  padding: 10px 30px 20px; /* reduce top space before cards */
  border: none !important;
  box-shadow: none !important;
}
.dashbored-wrap .com-record .followers-tag .box .text p.number {
  font-family: Arial !important;
}
.dashbored-wrap .com-record:after {
  content: "";
  width: 100%;
  height: 60%;
  /* background: gray; */
  top: 0px;
  position: absolute;
  left: 0px;
  z-index: 0;
}
.dashbored-wrap .ico-box {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dashbored-wrap .table-wrap {
  padding: 30px 30px 30px 0px;
  position: absolute;
  width: calc(100% - 30px);
  width: 100%;
  left: 0px;
  /* width:calc(100% - 76px); */
}
.dashbored-wrap .box {
  width: auto;
  padding: 5px 10px;
  background: #fff;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);
}
.dashbored-wrap .filter-ico li {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dashbored-wrap .filter-ico li i {
  color: #000;
}
.dashbored-wrap .filter-ico {
  display: flex;
  align-items: center;
}
.dashbored-wrap .filter-ico ul {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
}
.dashbored-wrap .filter-ico button[mat-icon-button] mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  line-height: 22px;
}
.dashbored-wrap .filter-bar {
  display: flex;
  width: 100%;
  gap: 16px;
  align-items: center;
}
.dashbored-wrap .filter-bar .input {
  flex: 0 0 auto;
}
.dashbored-wrap .search-container {
  position: relative;
  width: 400px;
  max-width: 100%;
  display: flex;
  align-items: center;
}
.dashbored-wrap .search-container .search-field {
  width: 100%;
  margin: 0;
}
.dashbored-wrap .search-container ::ng-deep .mat-mdc-form-field {
  width: 100%;
}
.dashbored-wrap .text {
  padding-right: 10px;
}
.dashbored-wrap .table-parent {
  overflow-x: auto;
  margin-top: -8px;
  overflow-y: auto;
  width: 100%;
  min-height: 300px;
}
.dashbored-wrap .mobile-cards {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-height: 400px;
}
.dashbored-wrap table {
  margin-bottom: 20px;
  width: 100%;
  background: white;
  border-radius: 0 0 8px 8px;
  overflow: hidden;
}
.dashbored-wrap th,
.dashbored-wrap td {
  border: none;
  color: #000;
  padding: 16px;
  min-width: 100px;
  font-family: "Raleway";
  vertical-align: middle;
}
.dashbored-wrap th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #e0e0e0;
}
.dashbored-wrap td {
  border-bottom: 1px solid #e0e0e0;
}
.dashbored-wrap td[scope=row] {
  position: relative;
}
.dashbored-wrap .inner {
  width: 100%;
  margin-bottom: 0px;
}
.dashbored-wrap .inner td {
  padding: 5px;
  border: 0px;
}
.dashbored-wrap .inner td:first-child {
  width: 30px;
}
.dashbored-wrap tbody tr {
  cursor: pointer;
  transition: background-color 0.2s;
}
.dashbored-wrap tbody tr:hover {
  background-color: #f9f9f9;
}
.dashbored-wrap tbody tr:hover td {
  color: #000;
}
.dashbored-wrap tbody tr:hover td .view-analytics,
.dashbored-wrap tbody tr:hover td .view-analytics *,
.dashbored-wrap tbody tr:hover td span.view-analytics,
.dashbored-wrap tbody tr:hover td span.view-analytics * {
  color: #5ea1d8 !important;
}
.dashbored-wrap tbody tr:last-child td {
  border-bottom: none;
}
.dashbored-wrap tbody tr span {
  display: flex;
  align-items: center;
}
@media (max-width: 768px) {
  .dashbored-wrap .view-analytics {
    color: #5ea1d8 !important;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    transition: color 0.2s ease;
  }
  .dashbored-wrap .view-analytics mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
    color: #5ea1d8;
  }
  .dashbored-wrap .view-analytics:hover {
    color: #4a8bc7 !important;
  }
  .dashbored-wrap .view-analytics:hover mat-icon {
    color: #4a8bc7;
  }
}
.dashbored-wrap tbody tr.no-data-row,
.dashbored-wrap tbody tr.no-data-row:hover {
  background: #fff !important;
}
.dashbored-wrap tbody tr.no-data-row td,
.dashbored-wrap tbody tr.no-data-row:hover td {
  color: #000 !important;
}
.dashbored-wrap .filter {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  border: none;
  padding: 0 0 16px;
}
.dashbored-wrap .filter-title {
  flex: 1;
}
.dashbored-wrap .filter ul {
  display: flex;
  float: right;
}
.dashbored-wrap .filter-bar {
  display: flex;
  width: 100%;
}
.dashbored-wrap .filter-ico {
  flex: 1;
}
.dashbored-wrap .search-container {
  position: relative;
}
.dashbored-wrap .filters-section {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: nowrap;
  align-items: center;
  overflow: visible;
  width: 100%;
}
.dashbored-wrap .filters-section .search-field ::ng-deep .mat-mdc-form-field-subscript-wrapper,
.dashbored-wrap .filters-section .flow-filter mat-form-field ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.dashbored-wrap .filters-section .search-field ::ng-deep .mat-mdc-form-field-infix,
.dashbored-wrap .filters-section .flow-filter mat-form-field ::ng-deep .mat-mdc-form-field-infix {
  min-height: 40px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.dashbored-wrap .filters-section .search-field ::ng-deep .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label,
.dashbored-wrap .filters-section .flow-filter mat-form-field ::ng-deep .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label {
  top: 20px;
}
.dashbored-wrap .filters-section .search-field ::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above,
.dashbored-wrap .filters-section .flow-filter mat-form-field ::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above {
  --mat-mdc-form-field-label-transform: translateY(-26.75px) scale(var(--mat-mdc-form-field-floating-label-scale, 0.75));
  transform: var(--mat-mdc-form-field-label-transform);
}
.dashbored-wrap .filters-section .search-filter {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 720px;
}
.dashbored-wrap .filters-section .search-filter .search-field {
  width: 100%;
}
.dashbored-wrap .filters-section .search-filter .search-field ::ng-deep .mat-mdc-form-field {
  width: 100%;
}
.dashbored-wrap .filters-section .search-filter .search-field ::ng-deep .mat-mdc-text-field-wrapper {
  width: 100%;
}
.dashbored-wrap .filters-section .flow-filter {
  flex: 0 0 220px;
  min-width: 180px;
  max-width: 240px;
  overflow: visible;
}
.dashbored-wrap .filters-section .flow-filter mat-form-field {
  width: 100%;
}
.dashbored-wrap .filters-section .flow-filter mat-form-field ::ng-deep .mat-mdc-form-field {
  width: 100%;
}
.dashbored-wrap .filters-section .flow-filter mat-form-field ::ng-deep .mat-mdc-text-field-wrapper {
  width: 100%;
}
.dashbored-wrap .search-input {
  width: 100%;
}
.dashbored-wrap .search-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
.dashbored-wrap .chekbox-image {
  display: flex;
}
.dashbored-wrap .chekbox-image td:first-child {
  width: unset;
  flex: 1;
  min-width: 150px;
  display: flex;
  align-items: flex-start;
}
.dashbored-wrap .chekbox-image td:first-child span {
  padding-left: 13px;
}
.dashbored-wrap .chekbox-image td:last-child {
  min-width: unset;
  width: 40px;
  display: flex;
  align-items: flex-start;
}
.dashbored-wrap .image-sec img,
.dashbored-wrap .image-sec .cover-media {
  display: block;
  width: 100%;
  max-width: 160px;
  height: 96px;
  object-fit: cover;
  object-position: center;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #f8fafc;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}
.dashbored-wrap .image-sec .cover-media--initial {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  cursor: pointer;
  object-fit: unset;
  background: #e2e8f0;
  color: #475569;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 0.02em;
  font-family: inherit;
  line-height: 1;
}
.dashbored-wrap .mobile-design {
  display: none;
}

@media (min-width: 768px) and (max-width: 1023px) {
  .dashbored-wrap .detail-list {
    display: none;
  }
  .dashbored-wrap .detail-description {
    width: 100%;
    left: 0px;
  }
  .dashbored-wrap .followers-tag {
    flex-wrap: wrap;
    width: 100%;
    gap: 20px;
  }
  .dashbored-wrap .followers-tag .box {
    margin: 0;
    width: calc(50% - 10px);
    min-width: 250px;
    flex: 1;
  }
  .dashbored-wrap .followers-tag .box .text {
    flex: 1;
  }
  .dashbored-wrap .com-record {
    padding: 20px;
  }
  .dashbored-wrap .com-record:after {
    height: 140px;
  }
  .dashbored-wrap .filter {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .dashbored-wrap .search-container .search-input {
    width: 100%;
    max-width: 400px;
  }
  .dashbored-wrap .top-menu-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .dashbored-wrap .table-wrap {
    top: unset;
    position: relative;
    padding: 20px;
  }
  .dashbored-wrap .table-wrap .table-parent {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .dashbored-wrap .mobile-design {
    display: none;
  }
  table {
    min-width: 600px;
  }
  table th,
  table td {
    padding: 14px 12px;
    font-size: 14px;
    min-width: 80px;
  }
  table th {
    font-size: 12px;
    font-weight: 600;
  }
  .followers-tag .box {
    padding: 15px;
  }
  .followers-tag .box .text {
    font-size: 14px;
  }
}
@media (min-width: 1024px) and (max-width: 1199px) {
  .dashbored-wrap .followers-tag .box {
    width: calc(33.333% - 14px);
    min-width: 200px;
  }
  .dashbored-wrap .table-wrap .table-parent {
    overflow-x: auto;
  }
  table th,
  table td {
    padding: 12px 8px;
    font-size: 13px;
    min-width: 70px;
  }
}
@media (max-width: 992px) {
  .dashbored-wrap .detail-list {
    display: none;
  }
  .dashbored-wrap .detail-description {
    width: 100%;
    left: 0px;
  }
  .dashbored-wrap .followers-tag {
    flex-wrap: wrap;
    width: 100%;
    gap: 16px;
  }
  .dashbored-wrap .followers-tag .box {
    margin: 0;
    width: 100%;
    min-width: 200px;
    flex: 1;
  }
  .dashbored-wrap .followers-tag .box .text {
    flex: 1;
  }
  .dashbored-wrap .com-record {
    padding: 7px !important;
    border: none !important;
  }
  .dashbored-wrap .com-record:after {
    height: 130px;
  }
  .dashbored-wrap .search-container .search-input {
    width: 100%;
  }
  .dashbored-wrap .top-menu-wrap {
    display: none;
  }
  .dashbored-wrap .table-wrap {
    top: unset;
  }
  .dashbored-wrap .table-wrap .table-parent {
    display: none;
  }
  .dashbored-wrap .mobile-design {
    padding: 20px 10px;
    background: lightblue;
    display: block;
    width: 100%;
    min-height: 400px;
  }
  .dashbored-wrap .mobile-design .tile {
    background: #fff;
    padding: 10px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    margin-bottom: 12px;
    width: 100%;
  }
  .dashbored-wrap .mobile-design .tile > div {
    border-bottom: 1px solid #ddd;
  }
  .dashbored-wrap .mobile-design .tile p {
    color: #212529 !important;
  }
  .dashbored-wrap .mobile-design .tile p.bold {
    font-weight: 700 !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  .dashbored-wrap .mobile-design .tile .main-title {
    display: flex;
    align-items: center;
    background: #5ea1d8;
    padding: 10px;
    margin-bottom: 10px;
  }
  .dashbored-wrap .mobile-design .tile .main-title h3 {
    margin-bottom: 0px !important;
    color: #fff !important;
  }
  .dashbored-wrap .mobile-design .first-tile div {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .dashbored-wrap .mobile-design .first-tile div span {
    display: flex;
    align-items: center;
  }
  .dashbored-wrap .mobile-design .first-tile input {
    position: relative;
    margin: 0px 10px 0px 0px;
    width: 20px;
    height: 20px;
  }
  .dashbored-wrap .mobile-design .first-tile .img {
    display: flex;
    align-items: flex-start;
  }
  .dashbored-wrap .mobile-design .first-tile .img .bundle {
    width: 30px;
    margin-right: 10px;
    height: 30px;
  }
  .dashbored-wrap .mobile-design .first-tile .img img,
  .dashbored-wrap .mobile-design .first-tile .img .cover-media {
    width: 120px;
    height: 80px;
    object-fit: cover;
    object-position: center;
    border-radius: 10px;
    border: 1px solid #e5e7eb;
    background: #f8fafc;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
  }
  .dashbored-wrap .mobile-design .first-tile .img .cover-media--initial {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;
    cursor: pointer;
    object-fit: unset;
    background: #e2e8f0;
    color: #475569;
    font-size: 28px;
    font-weight: 700;
    letter-spacing: 0.02em;
    font-family: inherit;
    line-height: 1;
  }
  .dashbored-wrap .mobile-design .common-tile {
    display: flex;
  }
  .dashbored-wrap .mobile-design .common-tile .title-tile {
    flex: 1;
    padding: 3px;
  }
}
/* new setting common design starts here*/
.setting-dashboard {
  padding: 0;
  height: 14vh;
  position: relative;
  margin-top: 0;
  background: var(--fc-bg, #fff);
}
.setting-dashboard .row {
  flex-direction: row;
  height: 100%;
  margin: 0px;
}
.setting-dashboard .left-user {
  background: #5ea1d8;
  position: relative;
  padding: 0 0 0 30px;
  position: fixed;
  height: 100vh;
  z-index: 3;
}
.setting-dashboard .left-user .collapse-btn {
  position: absolute;
  width: 25px;
  height: 25px;
  background: #5ea1d8;
  border-radius: 50%;
  right: -12.5px;
  top: 26px;
  border: 2px solid #fff;
  box-shadow: 0 0 3px #171717;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transform: rotate(180deg);
}
.setting-dashboard .left-user .dash-elemenet {
  height: calc(100vh - 180px);
}
.setting-dashboard .left-user .dash-elemenet ul {
  padding: 0px;
  margin: 0px;
  width: 100%;
  list-style-type: none;
}
.setting-dashboard .left-user .dash-elemenet ul li {
  height: 40px;
  margin-bottom: 10px;
  position: relative;
  display: flex;
  align-items: center;
  transition: all 0.5s linear;
  padding-left: 10px;
}
.setting-dashboard .left-user .dash-elemenet ul li:after {
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  height: 100%;
  left: 0%;
  position: absolute;
  background: #fff;
  background: #1d67a3;
  transition: all 0.5s linear;
  width: 0;
  z-index: -1;
}
.setting-dashboard .left-user .dash-elemenet ul li:hover:after, .setting-dashboard .left-user .dash-elemenet ul li:active:after, .setting-dashboard .left-user .dash-elemenet ul li:focus:after {
  content: "";
  width: 100%;
  left: 0;
  transition: all 0.5s linear;
}

.dashbored-wrap {
  padding-left: 0px;
  margin-top: 0;
}

.setting-dashboard .left-user .dash-title {
  position: unset;
  width: 100%;
}

.setting-dashboard .dash-title {
  height: 80px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  color: #fff;
  position: fixed;
  z-index: 2;
  top: var(--app-header);
}

.setting-dashboard .dash-title h6,
.setting-dashboard .dash-title .h6 {
  display: flex;
  align-items: center;
  font-weight: 500 !important;
  color: #fff !important;
}

.setting-dashboard .dash-title h6 span,
.setting-dashboard .dash-title .h6 span {
  width: auto !important;
  font-size: 20px;
  margin-right: 10px;
}

.setting-dashboard .dash-elemenet {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 1rem;
  height: calc(100vh - 220px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 20px;
}

.setting-dashboard .dash-elemenet > div {
  width: 100%;
  line-height: 26px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  color: #fff;
  transition: all 0.5slinear;
  position: relative;
  padding-bottom: 0;
  z-index: 2;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.left-user .selected-item {
  background: #1d67a3 !important;
  padding-left: 10px;
}

.setting-dashboard .left-user .dash-elemenet > div span {
  width: auto !important;
  font-size: 20px;
  margin-right: 10px;
}

/*right section*/
.setting-dashboard .submission-field {
  left: 16.666667%;
  padding-right: 0;
  position: fixed;
  position: absolute;
  top: 0px;
  width: 83.333333%;
  padding-left: 0px;
  border-left: 1px solid #fff;
}

.setting-dashboard .submission-field .hamburger {
  width: 100%;
  background: #985ce1;
  display: flex;
  position: relative;
}

.setting-dashboard .submission-field .hamburger .dash-title {
  padding-left: 15px;
  background: #5ea1d8;
  display: flex;
  color: #fff;
  width: 83.333333%;
}

.scroll-div {
  position: sticky;
  top: var(--app-header) !important; /* sit directly under header */
  margin-top: 0 !important;
  width: 100%;
  padding-bottom: 20px;
}
.scroll-div .dash-text {
  padding: 10px 15px 0; /* trim extra padding above cards */
}

.mat-mdc-tab-group {
  display: flex;
  flex-direction: column;
  max-width: 100%;
}

.setting-dashboard .dash-elemenet > div:after {
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  height: 100%;
  left: 0%;
  position: absolute;
  background: #fff;
  background: #6322b2;
  transition: width 0.5sease 0s, left 0.5sease 0s;
  width: 0;
  z-index: -1;
}

.setting-dashboard .dash-elemenet > div span:last-child {
  font-size: 12px !important;
}

@media (max-width: 767px) {
  .scroll-div {
    margin-top: 0 !important;
    padding-top: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    top: 0 !important;
  }
  .mob-menu {
    background: #5d9fd5 !important;
    position: sticky;
    top: var(--app-header, 56px);
    z-index: 1500;
    width: 100%;
    display: block !important;
  }
  .navbar {
    justify-content: flex-start;
    margin-bottom: 0px;
  }
  .mob-menu button {
    background: #5d9fd5 !important;
    margin-bottom: 0 !important;
    color: #fff;
    font-size: 14px;
    padding: 10px 5px;
    text-transform: capitalize;
    border: 1px solid #fff !important;
    box-shadow: none !important;
    display: flex !important;
    align-items: center;
  }
  .setting-dashboard .left-user {
    width: 59vw;
    position: fixed;
    top: calc(var(--app-header, 56px) + 48px);
    height: calc(100vh - (var(--app-header, 56px) + 48px));
    padding-left: 10px;
    left: -59vw;
    transition: left 0.5s linear;
    display: block !important;
    z-index: 1600;
  }
  .setting-dashboard .show-menu .left-user {
    left: 0px;
    transition: left 0.5s linear;
  }
  .setting-dashboard .submission-field {
    width: 100%;
    left: 0px;
  }
  .dashbored-wrap .table-wrap {
    padding: 0px;
  }
  .setting-dashboard .submission-field .hamburger .dash-title {
    width: 100%;
    top: calc(var(--app-header, 56px) + 48px);
    height: 40px;
  }
  .setting-dashboard .left-user .dash-title {
    display: none;
  }
  .setting-dashboard .left-user .collapse-btn {
    display: none;
  }
  .dashbored-wrap {
    margin-top: 10px !important;
  }
  .dashbored-wrap .mobile-design {
    padding: 20px;
  }
  .dashbored-wrap .com-record:after {
    height: 133px;
  }
  /* Search and filter bar: full width on mobile (same as card length) */
  .filter,
  .filters-section {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }
  .filters-section {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-bottom: 16px;
    padding: 0 20px;
  }
  .filters-section .search-filter {
    flex: 1 1 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
  }
  .filters-section .search-field,
  .filters-section .search-field ::ng-deep .mat-mdc-form-field,
  .filters-section .search-field ::ng-deep .mat-mdc-text-field-wrapper {
    width: 100% !important;
    max-width: 100% !important;
  }
  .filters-section .flow-filter {
    flex: 0 0 auto !important;
    min-width: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
  }
  .filters-section .flow-filter mat-form-field,
  .filters-section .flow-filter ::ng-deep .mat-mdc-form-field {
    width: 100% !important;
    max-width: 100% !important;
  }
}
.skeleton-stats-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
  width: 100%;
}

.skeleton-box {
  width: auto;
  padding: 5px 10px;
  background: #fff;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);
  min-width: 150px;
  flex: 1;
}

.skeleton-table-container {
  margin: 16px 0;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  width: 100%;
  min-height: 300px;
  overflow-x: auto;
}

.skeleton-mobile-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 16px 0;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  width: 100%;
  min-height: 400px;
}

.skeleton-text {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  height: 16px;
  margin: 4px 0;
}
.skeleton-text.skeleton-title {
  height: 20px;
  width: 80%;
}
.skeleton-text.skeleton-bold {
  height: 18px;
  width: 60%;
}
.skeleton-text.skeleton-count {
  height: 24px;
  width: 80px;
  margin-bottom: 8px;
}

.skeleton-checkbox {
  width: 20px;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 3px;
  margin-right: 10px;
}

.skeleton-icon {
  width: 20px;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 50%;
}

.skeleton-image {
  width: 100%;
  height: 80px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  object-fit: cover;
}

.skeleton-price {
  width: 60px;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  margin-left: 10px;
}

.skeleton-analytics {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.skeleton-tile {
  background: #fff;
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 12px;
  width: 100%;
}
.skeleton-tile .main-title {
  display: flex;
  align-items: center;
  background: #5ea1d8;
  padding: 10px;
  margin-bottom: 10px;
}
.skeleton-tile .main-title .skeleton-title {
  height: 24px;
  width: 70%;
}
.skeleton-tile .first-tile div {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.skeleton-tile .first-tile .img {
  display: flex;
  align-items: flex-start;
}
.skeleton-tile .first-tile .img .bundle {
  width: 30px;
  margin-right: 10px;
  height: 30px;
}
.skeleton-tile .common-tile {
  display: flex;
}
.skeleton-tile .common-tile .title-tile {
  flex: 1;
  padding: 3px;
}

@keyframes skeleton-loading {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
@media (max-width: 768px) {
  .skeleton-stats-container {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 12px;
    width: 100%;
    min-height: 150px;
  }
  .skeleton-table-container {
    padding: 12px;
    margin: 12px 0;
    width: 100%;
    min-height: 250px;
    display: block;
  }
  .skeleton-mobile-container {
    padding: 12px;
    margin: 12px 0;
    width: 100%;
    min-height: 300px;
    display: flex;
  }
}
@media (max-width: 480px) {
  .skeleton-stats-container {
    padding: 8px;
    gap: 8px;
    min-height: 120px;
  }
  .skeleton-table-container,
  .skeleton-mobile-container {
    padding: 8px;
    margin: 8px 0;
  }
  .skeleton-table-container {
    min-height: 200px;
  }
  .skeleton-mobile-container {
    min-height: 250px;
  }
}
/* Desktop guardrails to prevent cards/search overlap */
@media (min-width: 1366px) {
  .dashbored-wrap .com-record .stats-cards,
  .dashbored-wrap .com-record .followers-tag {
    margin-bottom: 24px;
  }
  .dashbored-wrap .table-wrap {
    top: 200px; /* push table/search below cards */
  }
}
@media (min-width: 1600px) {
  .dashbored-wrap .com-record .stats-cards,
  .dashbored-wrap .com-record .followers-tag {
    /* keep natural card height on desktop */
  }
  .dashbored-wrap .table-wrap {
    top: 230px;
  }
  /* Keep desktop card height as content-based (no forced min-height) */
  .dashbored-wrap .com-record .followers-tag .box,
  .dashbored-wrap .com-record .stats-cards .box {
    min-height: auto;
  }
}
@media (min-width: 1920px) {
  /* Keep card height as on desktop (natural/content-based) */
  .dashbored-wrap .com-record .followers-tag .box,
  .dashbored-wrap .com-record .stats-cards .box {
    min-height: auto;
  }
}
.no-results {
  text-align: center;
  padding: 40px 20px;
  color: #666;
  font-size: 16px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

@media (max-width: 768px) {
  ::ng-deep .analytics-dialog .mat-mdc-dialog-container {
    padding: 0 !important;
    margin: 0 !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
    width: 100vw !important;
    height: 100vh !important;
    border-radius: 0 !important;
  }
  ::ng-deep .analytics-dialog .mat-mdc-dialog-surface {
    padding: 0 !important;
    margin: 0 !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
    width: 100vw !important;
    height: 100vh !important;
    border-radius: 0 !important;
  }
  ::ng-deep .analytics-dialog .cdk-overlay-pane {
    max-width: 100vw !important;
    max-height: 100vh !important;
    width: 100vw !important;
    height: 100vh !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
  }
  ::ng-deep .analytics-dialog .cdk-overlay-backdrop {
    background-color: rgba(0, 0, 0, 0.5) !important;
  }
}
@media (max-width: 480px) {
  ::ng-deep .analytics-dialog .mat-mdc-dialog-container {
    padding: 0 !important;
    margin: 0 !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
    width: 100vw !important;
    height: 100vh !important;
    border-radius: 0 !important;
  }
  ::ng-deep .analytics-dialog .mat-mdc-dialog-surface {
    padding: 0 !important;
    margin: 0 !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
    width: 100vw !important;
    height: 100vh !important;
    border-radius: 0 !important;
  }
  ::ng-deep .analytics-dialog .cdk-overlay-pane {
    max-width: 100vw !important;
    max-height: 100vh !important;
    width: 100vw !important;
    height: 100vh !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
  }
}
:host-context(body.theme-dark) .table-wrap {
  top: 226px !important;
}
:host-context(body.theme-dark) .dashbored-wrap,
:host-context(body.theme-dark) .setting-dashboard,
:host-context(body.theme-dark) .scroll-div,
:host-context(body.theme-dark) .com-record,
:host-context(body.theme-dark) .table-wrap,
:host-context(body.theme-dark) .filter,
:host-context(body.theme-dark) .search-input,
:host-context(body.theme-dark) .detail-list,
:host-context(body.theme-dark) .detail-description {
  background: #111827 !important;
  background-color: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) table, :host-context(body.theme-dark) thead, :host-context(body.theme-dark) tbody, :host-context(body.theme-dark) tr, :host-context(body.theme-dark) td {
  background: #111827 !important;
  background-color: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) th {
  background: #0f172a !important;
  background-color: #0f172a !important;
  color: #94a3b8 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) tbody tr:hover {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
}
:host-context(body.theme-dark) tbody tr.no-data-row,
:host-context(body.theme-dark) tbody tr.no-data-row:hover {
  background: #111827 !important;
  background-color: #111827 !important;
}
:host-context(body.theme-dark) tbody tr.no-data-row td,
:host-context(body.theme-dark) tbody tr.no-data-row:hover td {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .box {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) p, :host-context(body.theme-dark) span:not(.material-icons):not(.view-analytics), :host-context(body.theme-dark) label, :host-context(body.theme-dark) li, :host-context(body.theme-dark) h1, :host-context(body.theme-dark) h2, :host-context(body.theme-dark) h3, :host-context(body.theme-dark) h4, :host-context(body.theme-dark) h5, :host-context(body.theme-dark) h6, :host-context(body.theme-dark) i, :host-context(body.theme-dark) b {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .view-analytics,
:host-context(body.theme-dark) td .view-analytics,
:host-context(body.theme-dark) td span.view-analytics,
:host-context(body.theme-dark) td .view-analytics *,
:host-context(body.theme-dark) .mobile-design .view-analytics {
  color: #5ea1d8 !important;
  background: transparent !important;
  background-color: transparent !important;
}
:host-context(body.theme-dark) .view-analytics mat-icon,
:host-context(body.theme-dark) td .view-analytics mat-icon,
:host-context(body.theme-dark) td span.view-analytics mat-icon,
:host-context(body.theme-dark) td .view-analytics * mat-icon,
:host-context(body.theme-dark) .mobile-design .view-analytics mat-icon {
  color: #5ea1d8 !important;
  background: transparent !important;
}
:host-context(body.theme-dark) .inner, :host-context(body.theme-dark) .inner tr, :host-context(body.theme-dark) .inner td {
  background: transparent !important;
  background-color: transparent !important;
}
:host-context(body.theme-dark) .mobile-design {
  background: #0f172a !important;
}
:host-context(body.theme-dark) .mobile-design .tile {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .mobile-design .tile p {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .skeleton-box,
:host-context(body.theme-dark) .skeleton-tile,
:host-context(body.theme-dark) .skeleton-table-container,
:host-context(body.theme-dark) .skeleton-mobile-container {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .skeleton-box table, :host-context(body.theme-dark) .skeleton-box thead, :host-context(body.theme-dark) .skeleton-box th, :host-context(body.theme-dark) .skeleton-box td, :host-context(body.theme-dark) .skeleton-box tr,
:host-context(body.theme-dark) .skeleton-tile table,
:host-context(body.theme-dark) .skeleton-tile thead,
:host-context(body.theme-dark) .skeleton-tile th,
:host-context(body.theme-dark) .skeleton-tile td,
:host-context(body.theme-dark) .skeleton-tile tr,
:host-context(body.theme-dark) .skeleton-table-container table,
:host-context(body.theme-dark) .skeleton-table-container thead,
:host-context(body.theme-dark) .skeleton-table-container th,
:host-context(body.theme-dark) .skeleton-table-container td,
:host-context(body.theme-dark) .skeleton-table-container tr,
:host-context(body.theme-dark) .skeleton-mobile-container table,
:host-context(body.theme-dark) .skeleton-mobile-container thead,
:host-context(body.theme-dark) .skeleton-mobile-container th,
:host-context(body.theme-dark) .skeleton-mobile-container td,
:host-context(body.theme-dark) .skeleton-mobile-container tr {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  color: #4b5563 !important;
}
:host-context(body.theme-dark) .skeleton-box thead tr,
:host-context(body.theme-dark) .skeleton-tile thead tr,
:host-context(body.theme-dark) .skeleton-table-container thead tr,
:host-context(body.theme-dark) .skeleton-mobile-container thead tr {
  background-color: #374151 !important;
}
:host-context(body.theme-dark) .skeleton-text,
:host-context(body.theme-dark) .skeleton-bold,
:host-context(body.theme-dark) .skeleton-count,
:host-context(body.theme-dark) .skeleton-title,
:host-context(body.theme-dark) .skeleton-checkbox,
:host-context(body.theme-dark) .skeleton-icon,
:host-context(body.theme-dark) .skeleton-image,
:host-context(body.theme-dark) .skeleton-price,
:host-context(body.theme-dark) .skeleton-analytics {
  background: linear-gradient(90deg, #1f2937 25%, #374151 50%, #1f2937 75%) !important;
  background-size: 200% 100% !important;
  animation: skeleton-loading 1.5s infinite !important;
}
:host-context(body.theme-dark) .no-results {
  background: #1f2937 !important;
  color: #94a3b8 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .collab-badge {
  background-color: #1e3a5f !important;
  color: #93c5fd !important;
  border-color: #2563eb !important;
}

body.theme-dark .dashbored-wrap,
body.theme-dark .setting-dashboard {
  background: var(--fc-bg) !important;
  color: var(--fc-fg) !important;
}

body.theme-dark .dashbored-wrap .top-menu-wrap,
body.theme-dark .dashbored-wrap .box,
body.theme-dark .dashbored-wrap .card,
body.theme-dark .dashbored-wrap .mat-mdc-card,
body.theme-dark .dashbored-wrap .tile,
body.theme-dark .dashbored-wrap .com-record,
body.theme-dark .dashbored-wrap .table-wrap,
body.theme-dark .dashbored-wrap .detail-list,
body.theme-dark .dashbored-wrap .filter,
body.theme-dark .dashbored-wrap .search-input,
body.theme-dark .dashbored-wrap .tab-content,
body.theme-dark .dashbored-wrap .followers-tag .box {
  background: var(--fc-bg2) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap table,
body.theme-dark .dashbored-wrap thead,
body.theme-dark .dashbored-wrap tbody,
body.theme-dark .dashbored-wrap tr,
body.theme-dark .dashbored-wrap td {
  background: var(--fc-bg) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap th {
  background: var(--fc-bg-head) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap tbody tr:hover {
  background: var(--fc-bg-hover) !important;
}

body.theme-dark .dashbored-wrap input,
body.theme-dark .dashbored-wrap select,
body.theme-dark .dashbored-wrap textarea {
  background: #0f172a !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap .mobile-design {
  background: var(--fc-bg) !important;
  color: var(--fc-fg) !important;
}

body.theme-dark .dashbored-wrap .mobile-design .tile {
  background: var(--fc-bg2) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap [class*=skeleton-] {
  background: var(--fc-skel) !important;
  color: transparent !important;
}

body.theme-dark .dashbored-wrap p,
body.theme-dark .dashbored-wrap label,
body.theme-dark .dashbored-wrap li,
body.theme-dark .dashbored-wrap h1,
body.theme-dark .dashbored-wrap h2,
body.theme-dark .dashbored-wrap h3,
body.theme-dark .dashbored-wrap h4,
body.theme-dark .dashbored-wrap h5,
body.theme-dark .dashbored-wrap h6 {
  color: var(--fc-fg) !important;
}

body.theme-dark .dashbored-wrap span:not(.material-icons):not(.badge):not([class*=status]):not(.view-analytics) {
  color: var(--fc-fg) !important;
}

/* Keep View Analytics links blue + no background in dark mode */
body.theme-dark .dashbored-wrap .view-analytics,
body.theme-dark .dashbored-wrap td .view-analytics,
body.theme-dark .dashbored-wrap td span.view-analytics,
body.theme-dark .dashbored-wrap td .view-analytics * {
  color: #5ea1d8 !important;
  background: transparent !important;
  background-color: transparent !important;
}

body.theme-dark .dashbored-wrap .view-analytics mat-icon {
  color: #5ea1d8 !important;
  background: transparent !important;
}

/* Remove box behind view-analytics row — inner table rows/cells must be transparent */
body.theme-dark .dashbored-wrap .inner,
body.theme-dark .dashbored-wrap .inner tr,
body.theme-dark .dashbored-wrap .inner td {
  background: transparent !important;
  background-color: transparent !important;
}

/* ── Override global white-background globals (.table-card, .fc-table, .big-box, .filter-section) ── */
body.theme-dark .table-card {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4) !important;
}

body.theme-dark .big-box {
  background: #111827 !important;
  background-color: #111827 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .fc-table {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
}

body.theme-dark .fc-table thead th {
  background-color: #0f172a !important;
  background: #0f172a !important;
  color: #94a3b8 !important;
  border-bottom-color: rgba(148, 163, 184, 0.25) !important;
  border-right-color: rgba(148, 163, 184, 0.15) !important;
}

body.theme-dark .fc-table tbody td {
  background-color: #1f2937 !important;
  color: #e2e8f0 !important;
  border-top-color: rgba(148, 163, 184, 0.15) !important;
  border-right-color: rgba(148, 163, 184, 0.1) !important;
}

body.theme-dark .fc-table tbody tr:nth-child(even) td {
  background-color: #253347 !important;
}

body.theme-dark .fc-table tbody tr:hover td {
  background-color: #374151 !important;
  color: #f1f5f9 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}

body.theme-dark .filter-section {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .filter-section label {
  color: #94a3b8 !important;
}

body.theme-dark .filter-section select,
body.theme-dark .filter-section input {
  background: #0f172a !important;
  background-color: #0f172a !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}

/* ── Dark scrollbars and overflow area fix ── */
body.theme-dark .table-parent {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
}

body.theme-dark .table-parent::-webkit-scrollbar,
body.theme-dark .table-card::-webkit-scrollbar {
  background: #111827;
  width: 6px;
  height: 6px;
}

body.theme-dark .table-parent::-webkit-scrollbar-track,
body.theme-dark .table-card::-webkit-scrollbar-track {
  background: #1f2937;
  border-radius: 4px;
}

body.theme-dark .table-parent::-webkit-scrollbar-thumb,
body.theme-dark .table-card::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 4px;
}

body.theme-dark .table-parent::-webkit-scrollbar-thumb:hover,
body.theme-dark .table-card::-webkit-scrollbar-thumb:hover {
  background: #4b5563;
}

body.theme-dark .table-parent::-webkit-scrollbar-corner,
body.theme-dark .table-card::-webkit-scrollbar-corner {
  background: #111827;
}

.collab-badge {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 12px;
  background-color: #e8f4fd;
  color: #1565c0;
  border: 1px solid #90caf9;
  vertical-align: middle;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/user-dashboard/dashboard/dashboard.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kBAAA;AAEF;;AACA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EAqIA,mDAAA;EAUA,iEAAA;EAyOA,2CAAA;EA2BA,uCAAA;EA2CA,0CAAA;AAvbF;AANE;EACE,YAAA;EACA,mBAAA;AAQJ;AANE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAQJ;AANE;EACE,aAAA;EACA,mBAAA;AAQJ;AANE;EACE,OAAA;EACA,aAAA;EACA,yBAAA;AAQJ;AANE;EACE,aAAA;EACA,mBAAA;AAQJ;AANE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAQJ;AALE;EACE,WAAA;EACA,aAAA;EAEA,gBAAA;AAMJ;AAJE;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EAEA,uBAAA;AAKJ;AAHE;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,kCAAA;EACA,2BAAA;AAKJ;AAHE;EACE,gBAAA;EACA,YAAA;EACA,WAAA;AAKJ;AAHE;EACE,mBAAA;AAKJ;AAGE;EACE,mBAAA;EACA,YAAA;EAEA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iDAAA;AAFJ;AAIE;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;EACA,SAAA;EACA,WAAA;AAFJ;AAIE;EACE,WAAA;AAFJ;AAIE;EACE;mBAAA;EAEA,WAAA;AAFJ;AAIE;EACE,WAAA;AAFJ;AAIE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EAEA,kBAAA;EAGA,wBAAA;AALJ;AAQE;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;AANJ;AAUE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA,EAAA,2DAAA;AARJ;AAWE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA,EAAA,+CAAA;AATJ;AAYE;EACE,uBAAA;EACA,gBAAA;AAVJ;AAYE;EACE,cAAA;AAVJ;AAYE;EACE,cAAA;AAVJ;AAYE;EACE,aAAA;EACA,sBAAA;AAVJ;AAaE;EACE,kCAAA;EACA,2BAAA;AAXJ;AAYI;EACE,eAAA;EACA,2BAAA;AAVN;AAaE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AAXJ;AAaE;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA,EAAA,kCAAA;EACA,uBAAA;EACA,2BAAA;AAXJ;AAoBU;EACE,6BAAA;AAlBZ;AAwBE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAtBJ;AAyBE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvBJ;AAyBE;EACE,2BAAA;EACA,kBAAA;EAEA,wBAAA;EACA,WAAA;EACA,SAAA;EACA,6BAAA;AAxBJ;AA0BE;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,oDAAA;AAxBJ;AA0BE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAxBJ;AA0BE;EACE,WAAA;AAxBJ;AA0BE;EACE,aAAA;EACA,mBAAA;AAxBJ;AA0BI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AAxBN;AA2BI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAzBN;AA4BE;EACE,aAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;AA1BJ;AA4BE;EACE,cAAA;AA1BJ;AA4BE;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AA1BJ;AA4BI;EACE,WAAA;EACA,SAAA;AA1BN;AA6BI;EACE,WAAA;AA3BN;AA8BE;EACE,mBAAA;AA5BJ;AA8BE;EACE,gBAAA;EACA,gBAAA;EAEA,gBAAA;EACA,WAAA;EACA,iBAAA;AA7BJ;AAiCE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;AA/BJ;AAiCE;EACE,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;AA/BJ;AAiCE;;EAEE,YAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;AA/BJ;AAiCE;EACE,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,gCAAA;AA/BJ;AAiCE;EACE,gCAAA;AA/BJ;AAiCE;EACE,kBAAA;AA/BJ;AAiCE;EACE,WAAA;EACA,kBAAA;AA/BJ;AAgCI;EACE,YAAA;EACA,WAAA;AA9BN;AA+BM;EACE,WAAA;AA7BR;AAiCE;EACE,eAAA;EACA,iCAAA;AA/BJ;AAmCI;EACE,yBAAA;AAjCN;AAkCM;EACE,WAAA;AAhCR;AAkCM;;;;EAIE,yBAAA;AAhCR;AAmCI;EACE,mBAAA;AAjCN;AAmCI;EACE,aAAA;EACA,mBAAA;AAjCN;AAsCE;EACE;IACE,yBAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,QAAA;IACA,eAAA;IACA,2BAAA;EApCJ;EAsCI;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,cAAA;EApCN;EAuCI;IACE,yBAAA;EArCN;EAuCM;IACE,cAAA;EArCR;AACF;AA0CE;;EAEE,2BAAA;AAxCJ;AAyCI;;EACE,sBAAA;AAtCN;AAiDE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AA/CJ;AAmDE;EACE,OAAA;AAjDJ;AAmDE;EACE,aAAA;EACA,YAAA;AAjDJ;AAmDE;EACE,aAAA;EACA,WAAA;AAjDJ;AAmDE;EACE,OAAA;AAjDJ;AAmDE;EACE,kBAAA;AAjDJ;AAqDE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AAnDJ;AAuDM;;EACE,aAAA;AApDR;AAuDM;;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AApDR;AAuDM;;EACE,SAAA;AApDR;AAuDM;;EACE,sHAAA;EACA,oDAAA;AApDR;AAwDI;EACE,cAAA;EACA,YAAA;EACA,gBAAA;AAtDN;AAwDM;EACE,WAAA;AAtDR;AAwDQ;EACE,WAAA;AAtDV;AAyDQ;EACE,WAAA;AAvDV;AA4DI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AA1DN;AA4DM;EACE,WAAA;AA1DR;AA4DQ;EACE,WAAA;AA1DV;AA6DQ;EACE,WAAA;AA3DV;AAiEE;EACE,WAAA;AA/DJ;AAkEE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;AAhEJ;AAmEE;EACE,aAAA;AAjEJ;AAmEM;EACE,YAAA;EACA,OAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AAjER;AAkEQ;EACE,kBAAA;AAhEV;AAmEM;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AAjER;AAsEI;;EAEE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4CAAA;AApEN;AAuEI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,cAAA;AArEN;AA8EE;EACE,aAAA;AA5EJ;;AAiFA;EAEI;IACE,aAAA;EA/EJ;EAiFE;IACE,WAAA;IACA,SAAA;EA/EJ;EAiFE;IACE,eAAA;IACA,WAAA;IACA,SAAA;EA/EJ;EAgFI;IACE,SAAA;IACA,uBAAA;IACA,gBAAA;IACA,OAAA;EA9EN;EA+EM;IACE,OAAA;EA7ER;EAiFE;IACE,aAAA;EA/EJ;EAgFI;IACE,aAAA;EA9EN;EAiFE;IACE,aAAA;IACA,eAAA;IACA,SAAA;EA/EJ;EAkFI;IACE,WAAA;IACA,gBAAA;EAhFN;EAmFE;IACE,aAAA;IACA,eAAA;IACA,SAAA;EAjFJ;EAmFE;IACE,UAAA;IACA,kBAAA;IACA,aAAA;EAjFJ;EAkFI;IACE,cAAA;IACA,gBAAA;IACA,iCAAA;EAhFN;EAmFE;IACE,aAAA;EAjFJ;EAsFA;IACE,gBAAA;EApFF;EAqFE;;IAEE,kBAAA;IACA,eAAA;IACA,eAAA;EAnFJ;EAqFE;IACE,eAAA;IACA,gBAAA;EAnFJ;EAyFE;IACE,aAAA;EAvFJ;EAwFI;IACE,eAAA;EAtFN;AACF;AA4FA;EAGM;IACE,2BAAA;IACA,gBAAA;EA5FN;EAgGI;IACE,gBAAA;EA9FN;EAoGE;;IAEE,iBAAA;IACA,eAAA;IACA,eAAA;EAlGJ;AACF;AAsGA;EAEI;IACE,aAAA;EArGJ;EAuGE;IACE,WAAA;IACA,SAAA;EArGJ;EAuGE;IACE,eAAA;IACA,WAAA;IACA,SAAA;EArGJ;EAsGI;IACE,SAAA;IACA,WAAA;IACA,gBAAA;IACA,OAAA;EApGN;EAqGM;IACE,OAAA;EAnGR;EAuGE;IACE,uBAAA;IACA,uBAAA;EArGJ;EAsGI;IACE,aAAA;EApGN;EA2GI;IACE,WAAA;EAzGN;EA4GE;IACE,aAAA;EA1GJ;EA4GE;IACE,UAAA;EA1GJ;EA2GI;IACE,aAAA;EAzGN;EA4GE;IACE,kBAAA;IACA,qBAAA;IACA,cAAA;IACA,WAAA;IACA,iBAAA;EA1GJ;EA4GI;IACE,gBAAA;IACA,aAAA;IACA,yBAAA;IACA,kBAAA;IACA,mBAAA;IACA,WAAA;EA1GN;EA2GM;IACE,6BAAA;EAzGR;EA2GM;IACE,yBAAA;EAzGR;EA2GM;IACE,2BAAA;IACA,oDAAA;EAzGR;EA2GM;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,aAAA;IACA,mBAAA;EAzGR;EA0GQ;IACE,6BAAA;IACA,sBAAA;EAxGV;EA6GM;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;EA3GR;EA4GQ;IACE,aAAA;IACA,mBAAA;EA1GV;EA8GM;IACE,kBAAA;IACA,wBAAA;IACA,WAAA;IACA,YAAA;EA5GR;EA8GM;IACE,aAAA;IACA,uBAAA;EA5GR;EA6GQ;IACE,WAAA;IACA,kBAAA;IACA,YAAA;EA3GV;EA6GQ;;IAEE,YAAA;IACA,YAAA;IACA,iBAAA;IACA,uBAAA;IACA,mBAAA;IACA,yBAAA;IACA,mBAAA;IACA,4CAAA;EA3GV;EA8GQ;IACE,oBAAA;IACA,mBAAA;IACA,uBAAA;IACA,UAAA;IACA,SAAA;IACA,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,cAAA;IACA,eAAA;IACA,gBAAA;IACA,sBAAA;IACA,oBAAA;IACA,cAAA;EA5GV;EAgHI;IACE,aAAA;EA9GN;EA+GM;IACE,OAAA;IACA,YAAA;EA7GR;AACF;AAmHA,yCAAA;AAEA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;AAlHF;AAmHE;EACE,mBAAA;EACA,YAAA;EACA,WAAA;AAjHJ;AAmHE;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;AAjHJ;AAkHI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,yBAAA;AAhHN;AAkHI;EACE,2BAAA;AAhHN;AAiHM;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;AA/GR;AAgHQ;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AA9GV;AA+GU;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,WAAA;AA7GZ;AA+GU;EAGE,WAAA;EACA,WAAA;EACA,OAAA;EACA,2BAAA;AA/GZ;;AAsHA;EACE,iBAAA;EACA,aAAA;AAnHF;;AAsHA;EACE,eAAA;EACA,WAAA;AAnHF;;AAqHA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,sBAAA;AAlHF;;AAoHA;;EAEE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;AAjHF;;AAmHA;;EAEE,sBAAA;EACA,eAAA;EACA,kBAAA;AAhHF;;AAmHA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAhHF;;AAkHA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AA/GF;;AAiHA;EACE,8BAAA;EACA,kBAAA;AA9GF;;AAgHA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;AA7GF;;AAgHA,gBAAA;AACA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;AA7GF;;AA+GA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AA5GF;;AA8GA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EAEA,WAAA;EAEA,iBAAA;AA7GF;;AA+GA;EACE,gBAAA;EACA,iCAAA,EAAA,8BAAA;EACA,wBAAA;EAEA,WAAA;EACA,oBAAA;AA7GF;AA8GE;EACE,oBAAA,EAAA,mCAAA;AA5GJ;;AAgHA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AA7GF;;AAgHA;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+CAAA;EACA,QAAA;EACA,WAAA;AA7GF;;AA+GA;EACE,0BAAA;AA5GF;;AA+GA;EACE;IACE,wBAAA;IACA,yBAAA;IACA,qBAAA;IACA,oBAAA;IACA,iBAAA;EA5GF;EA+GA;IACE,8BAAA;IACA,gBAAA;IACA,4BAAA;IACA,aAAA;IACA,WAAA;IACA,yBAAA;EA7GF;EA+GA;IACE,2BAAA;IACA,kBAAA;EA7GF;EA+GA;IACE,8BAAA;IACA,2BAAA;IACA,WAAA;IACA,eAAA;IACA,iBAAA;IACA,0BAAA;IACA,iCAAA;IACA,2BAAA;IACA,wBAAA;IACA,mBAAA;EA7GF;EA+GA;IACE,WAAA;IACA,eAAA;IACA,yCAAA;IACA,sDAAA;IACA,kBAAA;IACA,WAAA;IACA,4BAAA;IACA,yBAAA;IACA,aAAA;EA7GF;EA+GA;IACE,SAAA;IACA,4BAAA;EA7GF;EA+GA;IACE,WAAA;IACA,SAAA;EA7GF;EA+GA;IACE,YAAA;EA7GF;EA+GA;IACE,WAAA;IACA,yCAAA;IACA,YAAA;EA7GF;EA+GA;IACE,aAAA;EA7GF;EA+GA;IACE,aAAA;EA7GF;EA+GA;IACE,2BAAA;EA7GF;EA+GA;IACE,aAAA;EA7GF;EA+GA;IACE,aAAA;EA7GF;EAgHA,sEAAA;EACA;;IAEE,sBAAA;IACA,0BAAA;IACA,sBAAA;EA9GF;EAgHA;IACE,sBAAA;IACA,oBAAA;IACA,SAAA;IACA,mBAAA;IACA,eAAA;EA9GF;EAgHA;IACE,yBAAA;IACA,uBAAA;IACA,0BAAA;IACA,sBAAA;EA9GF;EAgHA;;;IAGE,sBAAA;IACA,0BAAA;EA9GF;EAgHA;IACE,yBAAA;IACA,uBAAA;IACA,0BAAA;IACA,sBAAA;EA9GF;EAgHA;;IAEE,sBAAA;IACA,0BAAA;EA9GF;AACF;AAkHA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AAhHF;;AAmHA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,oDAAA;EACA,gBAAA;EACA,OAAA;AAhHF;;AAmHA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AAhHF;;AAmHA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AAhHF;;AAoHA;EACE,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAjHF;AAmHE;EACE,YAAA;EACA,UAAA;AAjHJ;AAoHE;EACE,YAAA;EACA,UAAA;AAlHJ;AAqHE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AAnHJ;;AAuHA;EACE,WAAA;EACA,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;AApHF;;AAuHA;EACE,WAAA;EACA,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;AApHF;;AAuHA;EACE,WAAA;EACA,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,iBAAA;AApHF;;AAuHA;EACE,WAAA;EACA,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,iBAAA;AApHF;;AAuHA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AApHF;;AAuHA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AApHF;AAsHE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AApHJ;AAsHI;EACE,YAAA;EACA,UAAA;AApHN;AAyHI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAvHN;AA0HI;EACE,aAAA;EACA,uBAAA;AAxHN;AA0HM;EACE,WAAA;EACA,kBAAA;EACA,YAAA;AAxHR;AA6HE;EACE,aAAA;AA3HJ;AA6HI;EACE,OAAA;EACA,YAAA;AA3HN;;AAiIA;EACE;IACE,4BAAA;EA9HF;EAgIA;IACE,2BAAA;EA9HF;AACF;AAkIA;EACE;IACE,0BAAA;IACA,SAAA;IACA,aAAA;IACA,WAAA;IACA,iBAAA;EAhIF;EAmIA;IACE,aAAA;IACA,cAAA;IACA,WAAA;IACA,iBAAA;IACA,cAAA;EAjIF;EAoIA;IACE,aAAA;IACA,cAAA;IACA,WAAA;IACA,iBAAA;IACA,aAAA;EAlIF;AACF;AAqIA;EACE;IACE,YAAA;IACA,QAAA;IACA,iBAAA;EAnIF;EAsIA;;IAEE,YAAA;IACA,aAAA;EApIF;EAuIA;IACE,iBAAA;EArIF;EAwIA;IACE,iBAAA;EAtIF;AACF;AAyIA,uDAAA;AACA;EACE;;IAEE,mBAAA;EAvIF;EAyIA;IACE,UAAA,EAAA,kCAAA;EAvIF;AACF;AA0IA;EACE;;IAEE,wCAAA;EAxIF;EA0IA;IACE,UAAA;EAxIF;EA0IA,qEAAA;EACA;;IAEE,gBAAA;EAxIF;AACF;AA2IA;EACE,2DAAA;EACA;;IAEE,gBAAA;EAzIF;AACF;AA2IA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAzIF;;AA6IA;EAEI;IACE,qBAAA;IACA,oBAAA;IACA,2BAAA;IACA,4BAAA;IACA,uBAAA;IACA,wBAAA;IACA,2BAAA;EA3IJ;EA8IE;IACE,qBAAA;IACA,oBAAA;IACA,2BAAA;IACA,4BAAA;IACA,uBAAA;IACA,wBAAA;IACA,2BAAA;EA5IJ;EA+IE;IACE,2BAAA;IACA,4BAAA;IACA,uBAAA;IACA,wBAAA;IACA,0BAAA;IACA,iBAAA;IACA,kBAAA;EA7IJ;EAgJE;IACE,+CAAA;EA9IJ;AACF;AAkJA;EAEI;IACE,qBAAA;IACA,oBAAA;IACA,2BAAA;IACA,4BAAA;IACA,uBAAA;IACA,wBAAA;IACA,2BAAA;EAjJJ;EAoJE;IACE,qBAAA;IACA,oBAAA;IACA,2BAAA;IACA,4BAAA;IACA,uBAAA;IACA,wBAAA;IACA,2BAAA;EAlJJ;EAqJE;IACE,2BAAA;IACA,4BAAA;IACA,uBAAA;IACA,wBAAA;IACA,0BAAA;IACA,iBAAA;IACA,kBAAA;EAnJJ;AACF;AA2JE;EACE,qBAAA;AAzJJ;AA6JE;;;;;;;;;EASE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kDAAA;AA3JJ;AA+JE;EACE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kDAAA;AA7JJ;AA+JE;EACE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kDAAA;AA7JJ;AA+JE;EACE,8BAAA;EACA,oCAAA;AA7JJ;AA+JE;;EAEE,8BAAA;EACA,oCAAA;AA7JJ;AA8JI;;EAAK,yBAAA;AA1JT;AA8JE;EACE,8BAAA;EACA,oCAAA;EACA,kDAAA;EACA,yBAAA;AA5JJ;AAgKE;EACE,yBAAA;AA9JJ;AAkKE;;;;;EAKE,yBAAA;EACA,kCAAA;EACA,wCAAA;AAhKJ;AAiKI;;;;;EAAW,yBAAA;EAA2B,kCAAA;AAzJ1C;AA6JE;EACE,kCAAA;EACA,wCAAA;AA3JJ;AA+JE;EACE,8BAAA;AA7JJ;AA8JI;EACE,8BAAA;EACA,kDAAA;AA5JN;AA6JM;EAAI,yBAAA;AA1JV;AA+JE;;;;EAIE,8BAAA;EACA,oCAAA;EACA,iDAAA;AA7JJ;AA+JI;;;;;;;;;;;;;;;;EACE,8BAAA;EACA,oCAAA;EACA,iDAAA;EACA,yBAAA;AA9IN;AAgJI;;;;EAAW,oCAAA;AA1If;AA8IE;;;;;;;;;EASE,oFAAA;EACA,qCAAA;EACA,oDAAA;AA5IJ;AAgJE;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;AA9IJ;AAkJE;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AAhJJ;;AA0JA;;EAEE,mCAAA;EACA,8BAAA;AAvJF;;AA0JA;;;;;;;;;;;;EAYE,oCAAA;EACA,8BAAA;EACA,yCAAA;AAvJF;;AA0JA;;;;;EAKE,mCAAA;EACA,8BAAA;EACA,yCAAA;AAvJF;;AA0JA;EACE,wCAAA;EACA,8BAAA;EACA,yCAAA;AAvJF;;AA0JA;EACE,yCAAA;AAvJF;;AA0JA;;;EAGE,8BAAA;EACA,8BAAA;EACA,yCAAA;AAvJF;;AA0JA;EACE,mCAAA;EACA,8BAAA;AAvJF;;AA0JA;EACE,oCAAA;EACA,8BAAA;EACA,yCAAA;AAvJF;;AA0JA;EACE,qCAAA;EACA,6BAAA;AAvJF;;AA0JA;;;;;;;;;EASE,8BAAA;AAvJF;;AA0JA;EACE,8BAAA;AAvJF;;AA0JA,gEAAA;AACA;;;;EAIE,yBAAA;EACA,kCAAA;EACA,wCAAA;AAvJF;;AAyJA;EACE,yBAAA;EACA,kCAAA;AAtJF;;AAyJA,sFAAA;AACA;;;EAGE,kCAAA;EACA,wCAAA;AAtJF;;AAwJA,uGAAA;AACA;EACE,8BAAA;EACA,oCAAA;EACA,iDAAA;EACA,oDAAA;AArJF;;AAuJA;EACE,8BAAA;EACA,oCAAA;EACA,iDAAA;AApJF;;AAsJA;EACE,8BAAA;EACA,oCAAA;AAnJF;;AAqJA;EACE,oCAAA;EACA,8BAAA;EACA,yBAAA;EACA,yDAAA;EACA,wDAAA;AAlJF;;AAoJA;EACE,oCAAA;EACA,yBAAA;EACA,sDAAA;EACA,uDAAA;AAjJF;;AAmJA;EACE,oCAAA;AAhJF;;AAkJA;EACE,oCAAA;EACA,yBAAA;EACA,iDAAA;AA/IF;;AAiJA;EACE,8BAAA;EACA,oCAAA;EACA,iDAAA;AA9IF;;AAgJA;EACE,yBAAA;AA7IF;;AA+IA;;EAEE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,iDAAA;AA5IF;;AA+IA,gDAAA;AACA;EACE,8BAAA;EACA,oCAAA;AA5IF;;AA8IA;;EAEE,mBAAA;EACA,UAAA;EACA,WAAA;AA3IF;;AA6IA;;EAEE,mBAAA;EACA,kBAAA;AA1IF;;AA4IA;;EAEE,mBAAA;EACA,kBAAA;AAzIF;;AA2IA;;EAEE,mBAAA;AAxIF;;AA0IA;;EAEE,mBAAA;AAvIF;;AA0IA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;AAvIF","sourcesContent":["body {\n  overflow-x: hidden;\n}\n\n.dashbored-wrap {\n  width: 100%;\n  height: 100vh;\n  background: var(--fc-bg, #fff);\n  .logo {\n    width: 100px;\n    margin-right: 100px;\n  }\n  .top-menu-wrap {\n    display: flex;\n    align-items: center;\n    padding: 20px 10px;\n  }\n  .user-name {\n    display: flex;\n    align-items: center;\n  }\n  .user-details {\n    flex: 1;\n    display: flex;\n    justify-content: flex-end;\n  }\n  .user-name p {\n    display: flex;\n    align-items: center;\n  }\n  .user-name span {\n    width: 40px;\n    height: 40px;\n    background: red;\n    border-radius: 50%;\n    display: block;\n    margin-right: 10px;\n  }\n\n  .top-menu-wrap {\n    width: 100%;\n    height: 100px;\n\n    background: #fff;\n  }\n  .dash-details {\n    width: 100%;\n    display: flex;\n    max-height: 100vh;\n\n    /* background: green; */\n  }\n  .detail-list {\n    max-width: 250px;\n    width: 100%;\n    padding: 20px 10px;\n    background-color: #efeeee;\n    color: #212529;\n    position: fixed;\n    top: calc(var(--app-header) + 5px);\n    height: calc(100vh - 120px);\n  }\n  ul {\n    list-style: none;\n    padding: 0px;\n    margin: 0px;\n  }\n  p {\n    margin-bottom: 10px;\n  }\n  // .scroll-div {\n  //   position: absolute;\n  //   top: 120px !important;\n  //   width: 100%;\n  // }\n\n  ul li {\n    margin-bottom: 10px;\n    height: 40px;\n\n    padding: 0px 10px;\n    position: relative;\n    z-index: 1;\n    color: #212529;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    transition: width 0.3s ease 0s, left 0.3s ease 0s;\n  }\n  ul li:before {\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 100%;\n    left: 0px;\n    position: absolute;\n    background: #fff;\n    transition: width 0.3s ease 0s, left 0.3s ease 0s;\n    width: 0%;\n    z-index: -1;\n  }\n  ul li:hover {\n    color: #000;\n  }\n  ul li:hover:before {\n    /* background: #fff;\n    color: #212529; */\n    width: 100%;\n  }\n  .table-bordered {\n    border: 0px;\n  }\n  .detail-description {\n    width: 100%;\n    height: 100%;\n    padding: 0px;\n    // width: calc(100% - 250px);\n    position: absolute;\n    // left: 250px;\n    // top: 120px;\n    /* background: purple; */\n  }\n\n  .followers-tag {\n    display: flex;\n    position: relative;\n    z-index: 1;\n    width: 100%;\n    flex-wrap: wrap;\n    gap: 16px;\n  }\n\n  // Stats cards container\n  .stats-cards {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    width: 100%;\n    margin-bottom: 32px; /* extra space to prevent overlap with table at mid zooms */\n  }\n  /* Ensure cards show icon left, count/title right */\n  .stats-cards .box {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 12px;\n    box-shadow: none;\n    background-color: #fff;\n    margin-top: 0; /* ensure cards appear right after the header */\n  }\n  /* Remove gray background behind icon/count for dashboard cards */\n  .stats-cards .box .ico-box {\n    background: transparent;\n    border-radius: 0;\n  }\n  .stats-cards .box .ico-box .card-icon {\n    color: #5ea1d8;\n  }\n  .stats-cards .box .icon {\n    flex: 0 0 auto;\n  }\n  .stats-cards .box .text {\n    display: flex;\n    flex-direction: column;\n    // gap: 2px;\n  }\n  .cards-grid .box .text .count {\n    background: transparent !important;\n    box-shadow: none !important;\n    b {\n      font-size: 24px;\n      font-weight: 400 !important;\n    }\n  }\n  h3 {\n    position: relative;\n    z-index: 3;\n    color: #fff;\n    font-weight: normal;\n  }\n  .com-record {\n    width: calc(100% - 250px);\n    width: 100%;\n    height: auto;\n    position: relative;\n    z-index: 0;\n    padding: 10px 30px 20px; /* reduce top space before cards */\n    border: none !important;\n    box-shadow: none !important;\n    // position: fixed;\n    // top:80px;\n    // left:250px;\n    // background: white;\n    // z-index: 100;\n    .followers-tag {\n      .box {\n        .text {\n          p.number {\n            font-family: Arial !important;\n          }\n        }\n      }\n    }\n  }\n  .com-record:after {\n    content: \"\";\n    width: 100%;\n    height: 60%;\n    /* background: gray; */\n    top: 0px;\n    position: absolute;\n    left: 0px;\n    z-index: 0;\n    // background: #5ea1d8;\n  }\n  .ico-box {\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .table-wrap {\n    padding: 30px 30px 30px 0px;\n    position: absolute;\n    // top: 150px;\n    width: calc(100% - 30px);\n    width: 100%;\n    left: 0px;\n    /* width:calc(100% - 76px); */\n  }\n  .box {\n    width: auto;\n    padding: 5px 10px;\n    background: #fff;\n    margin-right: 20px;\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);\n  }\n  .filter-ico li {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .filter-ico li i {\n    color: #000;\n  }\n  .filter-ico {\n    display: flex;\n    align-items: center;\n\n    ul {\n      display: flex;\n      align-items: center;\n      margin: 0;\n      padding: 0;\n      list-style: none;\n    }\n\n    button[mat-icon-button] mat-icon {\n      font-size: 22px;\n      width: 22px;\n      height: 22px;\n      line-height: 22px;\n    }\n  }\n  .filter-bar {\n    display: flex;\n    width: 100%;\n    gap: 16px;\n    align-items: center;\n  }\n  .filter-bar .input {\n    flex: 0 0 auto;\n  }\n  .search-container {\n    position: relative;\n    width: 400px;\n    max-width: 100%;\n    display: flex;\n    align-items: center;\n\n    .search-field {\n      width: 100%;\n      margin: 0;\n    }\n\n    ::ng-deep .mat-mdc-form-field {\n      width: 100%;\n    }\n  }\n  .text {\n    padding-right: 10px;\n  }\n  .table-parent {\n    overflow-x: auto;\n    margin-top: -8px;\n    // max-height: 400px;\n    overflow-y: auto;\n    width: 100%;\n    min-height: 300px;\n  }\n\n  // Mobile cards container\n  .mobile-cards {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n    min-height: 400px;\n  }\n  table {\n    margin-bottom: 20px;\n    width: 100%;\n    background: white;\n    border-radius: 0 0 8px 8px;\n    overflow: hidden;\n  }\n  th,\n  td {\n    border: none;\n    color: #000;\n    padding: 16px;\n    min-width: 100px;\n    font-family: \"Raleway\";\n    vertical-align: middle;\n  }\n  th {\n    background-color: #f5f5f5;\n    font-weight: 600;\n    color: #333;\n    text-transform: uppercase;\n    font-size: 12px;\n    letter-spacing: 0.5px;\n    border-bottom: 2px solid #e0e0e0;\n  }\n  td {\n    border-bottom: 1px solid #e0e0e0;\n  }\n  td[scope=\"row\"] {\n    position: relative;\n  }\n  .inner {\n    width: 100%;\n    margin-bottom: 0px;\n    td {\n      padding: 5px;\n      border: 0px;\n      &:first-child {\n        width: 30px;\n      }\n    }\n  }\n  tbody tr {\n    cursor: pointer;\n    transition: background-color 0.2s;\n    &:first-child {\n      // display: flex;\n    }\n    &:hover {\n      background-color: #f9f9f9;\n      td {\n        color: #000;\n      }\n      td .view-analytics,\n      td .view-analytics *,\n      td span.view-analytics,\n      td span.view-analytics * {\n        color: #5ea1d8 !important;\n      }\n    }\n    &:last-child td {\n      border-bottom: none;\n    }\n    span {\n      display: flex;\n      align-items: center;\n    }\n  }\n  \n  /* Mobile view - Blue View Analytics text */\n  @media (max-width: 768px) {\n    .view-analytics {\n      color: #5ea1d8 !important;\n      font-weight: 500;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      cursor: pointer;\n      transition: color 0.2s ease;\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n        color: #5ea1d8;\n      }\n\n      &:hover {\n        color: #4a8bc7 !important;\n        \n        mat-icon {\n          color: #4a8bc7;\n        }\n      }\n    }\n  }\n  /* prevent hover effect for empty row */\n  tbody tr.no-data-row,\n  tbody tr.no-data-row:hover {\n    background: #fff !important;\n    td {\n      color: #000 !important;\n    }\n  }\n  // tr:nth-child(even){\n  //     background: #5ea1d8;\n\n  // }\n  // tr:nth-child(even) td{\n  //     color: #fff;\n  // }\n\n  .filter {\n    display: flex;\n    align-items: center;\n    margin-bottom: 0;\n    border: none;\n    padding: 0 0 16px;\n    // position: fixed;\n    // width:calc(100% - 250px);\n  }\n  .filter-title {\n    flex: 1;\n  }\n  .filter ul {\n    display: flex;\n    float: right;\n  }\n  .filter-bar {\n    display: flex;\n    width: 100%;\n  }\n  .filter-ico {\n    flex: 1;\n  }\n  .search-container {\n    position: relative;\n  }\n\n  /* Flow Reviews–style filters/search bar */\n  .filters-section {\n    display: flex;\n    gap: 16px;\n    margin-bottom: 24px;\n    flex-wrap: nowrap;\n    align-items: center;\n    overflow: visible;\n    width: 100%;\n\n    .search-field,\n    .flow-filter mat-form-field {\n      ::ng-deep .mat-mdc-form-field-subscript-wrapper {\n        display: none;\n      }\n\n      ::ng-deep .mat-mdc-form-field-infix {\n        min-height: 40px;\n        padding-top: 8px;\n        padding-bottom: 8px;\n      }\n\n      ::ng-deep .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label {\n        top: 20px;\n      }\n\n      ::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above {\n        --mat-mdc-form-field-label-transform: translateY(-26.75px) scale(var(--mat-mdc-form-field-floating-label-scale, 0.75));\n        transform: var(--mat-mdc-form-field-label-transform);\n      }\n    }\n\n    .search-filter {\n      flex: 1 1 auto;\n      min-width: 0;\n      max-width: 720px;\n\n      .search-field {\n        width: 100%;\n\n        ::ng-deep .mat-mdc-form-field {\n          width: 100%;\n        }\n\n        ::ng-deep .mat-mdc-text-field-wrapper {\n          width: 100%;\n        }\n      }\n    }\n\n    .flow-filter {\n      flex: 0 0 220px;\n      min-width: 180px;\n      max-width: 240px;\n      overflow: visible;\n\n      mat-form-field {\n        width: 100%;\n\n        ::ng-deep .mat-mdc-form-field {\n          width: 100%;\n        }\n\n        ::ng-deep .mat-mdc-text-field-wrapper {\n          width: 100%;\n        }\n      }\n    }\n  }\n\n  .search-input {\n    width: 100%;\n  }\n\n  .search-icon {\n    position: absolute;\n    top: 50%;\n    right: 10px;\n    transform: translateY(-50%);\n  }\n\n  .chekbox-image {\n    display: flex;\n    td {\n      &:first-child {\n        width: unset;\n        flex: 1;\n        min-width: 150px;\n        display: flex;\n        align-items: flex-start;\n        span {\n          padding-left: 13px;\n        }\n      }\n      &:last-child {\n        min-width: unset;\n        width: 40px;\n        display: flex;\n        align-items: flex-start;\n      }\n    }\n  }\n  .image-sec {\n    img,\n    .cover-media {\n      display: block;\n      width: 100%;\n      max-width: 160px;\n      height: 96px;\n      object-fit: cover;\n      object-position: center;\n      border-radius: 10px;\n      border: 1px solid #e5e7eb;\n      background: #f8fafc;\n      box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n    }\n\n    .cover-media--initial {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      padding: 0;\n      margin: 0;\n      cursor: pointer;\n      object-fit: unset;\n      background: #e2e8f0;\n      color: #475569;\n      font-size: 32px;\n      font-weight: 700;\n      letter-spacing: 0.02em;\n      font-family: inherit;\n      line-height: 1;\n    }\n  }\n  .bundel {\n    span {\n      img {\n      }\n    }\n  }\n  .mobile-design {\n    display: none;\n  }\n}\n\n// Tablet-specific styles (768px - 1023px)\n@media (min-width: 768px) and (max-width: 1023px) {\n  .dashbored-wrap {\n    .detail-list {\n      display: none;\n    }\n    .detail-description {\n      width: 100%;\n      left: 0px;\n    }\n    .followers-tag {\n      flex-wrap: wrap;\n      width: 100%;\n      gap: 20px;\n      .box {\n        margin: 0;\n        width: calc(50% - 10px);\n        min-width: 250px;\n        flex: 1;\n        .text {\n          flex: 1;\n        }\n      }\n    }\n    .com-record {\n      padding: 20px;\n      &:after {\n        height: 140px;\n      }\n    }\n    .filter {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 10px;\n    }\n    .search-container {\n      .search-input {\n        width: 100%;\n        max-width: 400px;\n      }\n    }\n    .top-menu-wrap {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 10px;\n    }\n    .table-wrap {\n      top: unset;\n      position: relative;\n      padding: 20px;\n      .table-parent {\n        display: block;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n      }\n    }\n    .mobile-design {\n      display: none;\n    }\n  }\n\n  // Tablet table optimizations\n  table {\n    min-width: 600px;\n    th,\n    td {\n      padding: 14px 12px;\n      font-size: 14px;\n      min-width: 80px;\n    }\n    th {\n      font-size: 12px;\n      font-weight: 600;\n    }\n  }\n\n  // Tablet stats cards\n  .followers-tag {\n    .box {\n      padding: 15px;\n      .text {\n        font-size: 14px;\n      }\n    }\n  }\n}\n\n// Large tablets and small laptops (1024px - 1199px)\n@media (min-width: 1024px) and (max-width: 1199px) {\n  .dashbored-wrap {\n    .followers-tag {\n      .box {\n        width: calc(33.333% - 14px);\n        min-width: 200px;\n      }\n    }\n    .table-wrap {\n      .table-parent {\n        overflow-x: auto;\n      }\n    }\n  }\n\n  table {\n    th,\n    td {\n      padding: 12px 8px;\n      font-size: 13px;\n      min-width: 70px;\n    }\n  }\n}\n\n@media (max-width: 992px) {\n  .dashbored-wrap {\n    .detail-list {\n      display: none;\n    }\n    .detail-description {\n      width: 100%;\n      left: 0px;\n    }\n    .followers-tag {\n      flex-wrap: wrap;\n      width: 100%;\n      gap: 16px;\n      .box {\n        margin: 0;\n        width: 100%;\n        min-width: 200px;\n        flex: 1;\n        .text {\n          flex: 1;\n        }\n      }\n    }\n    .com-record {\n      padding: 7px !important;\n      border: none !important;\n      &:after {\n        height: 130px;\n      }\n    }\n    .filter {\n      // display: none;\n    }\n    .search-container {\n      .search-input {\n        width: 100%;\n      }\n    }\n    .top-menu-wrap {\n      display: none;\n    }\n    .table-wrap {\n      top: unset;\n      .table-parent {\n        display: none;\n      }\n    }\n    .mobile-design {\n      padding: 20px 10px;\n      background: lightblue;\n      display: block;\n      width: 100%;\n      min-height: 400px;\n\n      .tile {\n        background: #fff;\n        padding: 10px;\n        border: 1px solid #e0e0e0;\n        border-radius: 8px;\n        margin-bottom: 12px;\n        width: 100%;\n        & > div {\n          border-bottom: 1px solid #ddd;\n        }\n        p {\n          color: #212529 !important;\n        }\n        p.bold {\n          font-weight: 700 !important;\n          font-family: Arial, Helvetica, sans-serif !important;\n        }\n        .main-title {\n          display: flex;\n          align-items: center;\n          background: #5ea1d8;\n          padding: 10px;\n          margin-bottom: 10px;\n          h3 {\n            margin-bottom: 0px !important;\n            color: #fff !important;\n          }\n        }\n      }\n      .first-tile {\n        div {\n          display: flex;\n          align-items: center;\n          margin-bottom: 10px;\n          span {\n            display: flex;\n            align-items: center;\n          }\n        }\n\n        input {\n          position: relative;\n          margin: 0px 10px 0px 0px;\n          width: 20px;\n          height: 20px;\n        }\n        .img {\n          display: flex;\n          align-items: flex-start;\n          .bundle {\n            width: 30px;\n            margin-right: 10px;\n            height: 30px;\n          }\n          img,\n          .cover-media {\n            width: 120px;\n            height: 80px;\n            object-fit: cover;\n            object-position: center;\n            border-radius: 10px;\n            border: 1px solid #e5e7eb;\n            background: #f8fafc;\n            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n          }\n\n          .cover-media--initial {\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            padding: 0;\n            margin: 0;\n            cursor: pointer;\n            object-fit: unset;\n            background: #e2e8f0;\n            color: #475569;\n            font-size: 28px;\n            font-weight: 700;\n            letter-spacing: 0.02em;\n            font-family: inherit;\n            line-height: 1;\n          }\n        }\n      }\n      .common-tile {\n        display: flex;\n        .title-tile {\n          flex: 1;\n          padding: 3px;\n        }\n      }\n    }\n  }\n}\n\n/* new setting common design starts here*/\n\n.setting-dashboard {\n  padding: 0;\n  height: 14vh;\n  position: relative;\n  margin-top: 0;\n  background: var(--fc-bg, #fff);\n  .row {\n    flex-direction: row;\n    height: 100%;\n    margin: 0px;\n  }\n  .left-user {\n    background: #5ea1d8;\n    position: relative;\n    padding: 0 0 0 30px;\n    position: fixed;\n    height: 100vh;\n    z-index: 3;\n    .collapse-btn {\n      position: absolute;\n      width: 25px;\n      height: 25px;\n      background: #5ea1d8;\n      border-radius: 50%;\n      right: -12.5px;\n      top: 26px;\n      border: 2px solid #fff;\n      box-shadow: 0 0 3px #171717;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: #fff;\n      transform: rotate(180deg);\n    }\n    .dash-elemenet {\n      height: calc(100vh - 180px);\n      ul {\n        padding: 0px;\n        margin: 0px;\n        width: 100%;\n        list-style-type: none;\n        li {\n          height: 40px;\n          margin-bottom: 10px;\n          position: relative;\n          display: flex;\n          align-items: center;\n          transition: all 0.5s linear;\n          padding-left: 10px;\n          &:after {\n            bottom: 0;\n            content: \"\";\n            display: block;\n            height: 1px;\n            height: 100%;\n            left: 0%;\n            position: absolute;\n            background: #fff;\n            background: #1d67a3;\n            transition: all 0.5s linear;\n            width: 0;\n            z-index: -1;\n          }\n          &:hover:after,\n          &:active:after,\n          &:focus:after {\n            content: \"\";\n            width: 100%;\n            left: 0;\n            transition: all 0.5s linear;\n          }\n        }\n      }\n    }\n  }\n}\n.dashbored-wrap {\n  padding-left: 0px;\n  margin-top: 0;\n}\n\n.setting-dashboard .left-user .dash-title {\n  position: unset;\n  width: 100%;\n}\n.setting-dashboard .dash-title {\n  height: 80px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  color: #fff;\n  position: fixed;\n  z-index: 2;\n  top: var(--app-header);\n}\n.setting-dashboard .dash-title h6,\n.setting-dashboard .dash-title .h6 {\n  display: flex;\n  align-items: center;\n  font-weight: 500 !important;\n  color: #fff !important;\n}\n.setting-dashboard .dash-title h6 span,\n.setting-dashboard .dash-title .h6 span {\n  width: auto !important;\n  font-size: 20px;\n  margin-right: 10px;\n}\n\n.setting-dashboard .dash-elemenet {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  margin-top: 1rem;\n  height: calc(100vh - 220px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 20px;\n}\n.setting-dashboard .dash-elemenet > div {\n  width: 100%;\n  line-height: 26px;\n  margin-bottom: 10px;\n  font-size: 13px;\n  font-weight: 400;\n  cursor: pointer;\n  color: #fff;\n  transition: all 0.5slinear;\n  position: relative;\n  padding-bottom: 0;\n  z-index: 2;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n}\n.left-user .selected-item {\n  background: #1d67a3 !important;\n  padding-left: 10px;\n}\n.setting-dashboard .left-user .dash-elemenet > div span {\n  width: auto !important;\n  font-size: 20px;\n  margin-right: 10px;\n}\n\n/*right section*/\n.setting-dashboard .submission-field {\n  left: 16.666667%;\n  padding-right: 0;\n  position: fixed;\n  position: absolute;\n  top: 0px;\n  width: 83.333333%;\n  padding-left: 0px;\n  border-left: 1px solid #fff;\n}\n.setting-dashboard .submission-field .hamburger {\n  width: 100%;\n  background: #985ce1;\n  display: flex;\n  position: relative;\n}\n.setting-dashboard .submission-field .hamburger .dash-title {\n  padding-left: 15px;\n  background: #5ea1d8;\n  display: flex;\n  // border-left: 1px solid #fff;\n  color: #fff;\n  // left: 16.666667%;\n  width: 83.333333%;\n}\n.scroll-div {\n  position: sticky;\n  top: var(--app-header) !important; /* sit directly under header */\n  margin-top: 0 !important;\n  // margin-top: -16px !important;\n  width: 100%;\n  padding-bottom: 20px;\n  .dash-text {\n    padding: 10px 15px 0; /* trim extra padding above cards */\n  }\n}\n\n.mat-mdc-tab-group {\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n}\n\n.setting-dashboard .dash-elemenet > div:after {\n  bottom: 0;\n  content: \"\";\n  display: block;\n  height: 1px;\n  height: 100%;\n  left: 0%;\n  position: absolute;\n  background: #fff;\n  background: #6322b2;\n  transition: width 0.5sease 0s, left 0.5sease 0s;\n  width: 0;\n  z-index: -1;\n}\n.setting-dashboard .dash-elemenet > div span:last-child {\n  font-size: 12px !important;\n}\n\n@media (max-width: 767px) {\n  .scroll-div {\n    margin-top: 0 !important;\n    padding-top: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    top: 0 !important;\n  }\n  \n  .mob-menu {\n    background: #5d9fd5 !important;\n    position: sticky;\n    top: var(--app-header, 56px);\n    z-index: 1500;\n    width: 100%;\n    display: block !important;\n  }\n  .navbar {\n    justify-content: flex-start;\n    margin-bottom: 0px;\n  }\n  .mob-menu button {\n    background: #5d9fd5 !important;\n    margin-bottom: 0 !important;\n    color: #fff;\n    font-size: 14px;\n    padding: 10px 5px;\n    text-transform: capitalize;\n    border: 1px solid #fff !important;\n    box-shadow: none !important;\n    display: flex !important;\n    align-items: center;\n  }\n  .setting-dashboard .left-user {\n    width: 59vw;\n    position: fixed;\n    top: calc(var(--app-header, 56px) + 48px);\n    height: calc(100vh - (var(--app-header, 56px) + 48px));\n    padding-left: 10px;\n    left: -59vw;\n    transition: left 0.5s linear;\n    display: block !important;\n    z-index: 1600;\n  }\n  .setting-dashboard .show-menu .left-user {\n    left: 0px;\n    transition: left 0.5s linear;\n  }\n  .setting-dashboard .submission-field {\n    width: 100%;\n    left: 0px;\n  }\n  .dashbored-wrap .table-wrap {\n    padding: 0px;\n  }\n  .setting-dashboard .submission-field .hamburger .dash-title {\n    width: 100%;\n    top: calc(var(--app-header, 56px) + 48px);\n    height: 40px;\n  }\n  .setting-dashboard .left-user .dash-title {\n    display: none;\n  }\n  .setting-dashboard .left-user .collapse-btn {\n    display: none;\n  }\n  .dashbored-wrap {\n    margin-top: 10px !important;\n  }\n  .dashbored-wrap .mobile-design {\n    padding: 20px;\n  }\n  .dashbored-wrap .com-record:after {\n    height: 133px;\n  }\n\n  /* Search and filter bar: full width on mobile (same as card length) */\n  .filter,\n  .filters-section {\n    width: 100% !important;\n    max-width: 100% !important;\n    box-sizing: border-box;\n  }\n  .filters-section {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    margin-bottom: 16px;\n    padding: 0 20px;\n  }\n  .filters-section .search-filter {\n    flex: 1 1 100% !important;\n    min-width: 0 !important;\n    max-width: 100% !important;\n    width: 100% !important;\n  }\n  .filters-section .search-field,\n  .filters-section .search-field ::ng-deep .mat-mdc-form-field,\n  .filters-section .search-field ::ng-deep .mat-mdc-text-field-wrapper {\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n  .filters-section .flow-filter {\n    flex: 0 0 auto !important;\n    min-width: 0 !important;\n    max-width: 100% !important;\n    width: 100% !important;\n  }\n  .filters-section .flow-filter mat-form-field,\n  .filters-section .flow-filter ::ng-deep .mat-mdc-form-field {\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n}\n\n// Skeleton Loader Styles\n.skeleton-stats-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 24px;\n  width: 100%;\n}\n\n.skeleton-box {\n  width: auto;\n  padding: 5px 10px;\n  background: #fff;\n  margin-right: 20px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);\n  min-width: 150px;\n  flex: 1;\n}\n\n.skeleton-table-container {\n  margin: 16px 0;\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  width: 100%;\n  min-height: 300px;\n  overflow-x: auto;\n}\n\n.skeleton-mobile-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin: 16px 0;\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  width: 100%;\n  min-height: 400px;\n}\n\n// Skeleton element styles\n.skeleton-text {\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  height: 16px;\n  margin: 4px 0;\n\n  &.skeleton-title {\n    height: 20px;\n    width: 80%;\n  }\n\n  &.skeleton-bold {\n    height: 18px;\n    width: 60%;\n  }\n\n  &.skeleton-count {\n    height: 24px;\n    width: 80px;\n    margin-bottom: 8px;\n  }\n}\n\n.skeleton-checkbox {\n  width: 20px;\n  height: 20px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 3px;\n  margin-right: 10px;\n}\n\n.skeleton-icon {\n  width: 20px;\n  height: 20px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 50%;\n}\n\n.skeleton-image {\n  width: 100%;\n  height: 80px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  object-fit: cover;\n}\n\n.skeleton-price {\n  width: 60px;\n  height: 20px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  margin-left: 10px;\n}\n\n.skeleton-analytics {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.skeleton-tile {\n  background: #fff;\n  padding: 10px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  width: 100%;\n\n  .main-title {\n    display: flex;\n    align-items: center;\n    background: #5ea1d8;\n    padding: 10px;\n    margin-bottom: 10px;\n\n    .skeleton-title {\n      height: 24px;\n      width: 70%;\n    }\n  }\n\n  .first-tile {\n    div {\n      display: flex;\n      align-items: center;\n      margin-bottom: 10px;\n    }\n\n    .img {\n      display: flex;\n      align-items: flex-start;\n\n      .bundle {\n        width: 30px;\n        margin-right: 10px;\n        height: 30px;\n      }\n    }\n  }\n\n  .common-tile {\n    display: flex;\n\n    .title-tile {\n      flex: 1;\n      padding: 3px;\n    }\n  }\n}\n\n// Skeleton loading animation\n@keyframes skeleton-loading {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n// Mobile responsiveness for skeleton containers\n@media (max-width: 768px) {\n  .skeleton-stats-container {\n    grid-template-columns: 1fr;\n    gap: 12px;\n    padding: 12px;\n    width: 100%;\n    min-height: 150px;\n  }\n\n  .skeleton-table-container {\n    padding: 12px;\n    margin: 12px 0;\n    width: 100%;\n    min-height: 250px;\n    display: block;\n  }\n\n  .skeleton-mobile-container {\n    padding: 12px;\n    margin: 12px 0;\n    width: 100%;\n    min-height: 300px;\n    display: flex;\n  }\n}\n\n@media (max-width: 480px) {\n  .skeleton-stats-container {\n    padding: 8px;\n    gap: 8px;\n    min-height: 120px;\n  }\n\n  .skeleton-table-container,\n  .skeleton-mobile-container {\n    padding: 8px;\n    margin: 8px 0;\n  }\n\n  .skeleton-table-container {\n    min-height: 200px;\n  }\n\n  .skeleton-mobile-container {\n    min-height: 250px;\n  }\n}\n\n/* Desktop guardrails to prevent cards/search overlap */\n@media (min-width: 1366px) {\n  .dashbored-wrap .com-record .stats-cards,\n  .dashbored-wrap .com-record .followers-tag {\n    margin-bottom: 24px;\n  }\n  .dashbored-wrap .table-wrap {\n    top: 200px; /* push table/search below cards */\n  }\n}\n\n@media (min-width: 1600px) {\n  .dashbored-wrap .com-record .stats-cards,\n  .dashbored-wrap .com-record .followers-tag {\n    /* keep natural card height on desktop */\n  }\n  .dashbored-wrap .table-wrap {\n    top: 230px;\n  }\n  /* Keep desktop card height as content-based (no forced min-height) */\n  .dashbored-wrap .com-record .followers-tag .box,\n  .dashbored-wrap .com-record .stats-cards .box {\n    min-height: auto;\n  }\n}\n\n@media (min-width: 1920px) {\n  /* Keep card height as on desktop (natural/content-based) */\n  .dashbored-wrap .com-record .followers-tag .box,\n  .dashbored-wrap .com-record .stats-cards .box {\n    min-height: auto;\n  }\n}\n.no-results {\n  text-align: center;\n  padding: 40px 20px;\n  color: #666;\n  font-size: 16px;\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n// Mobile Dialog Responsive Fixes for Analytics\n@media (max-width: 768px) {\n  ::ng-deep .analytics-dialog {\n    .mat-mdc-dialog-container {\n      padding: 0 !important;\n      margin: 0 !important;\n      max-width: 100vw !important;\n      max-height: 100vh !important;\n      width: 100vw !important;\n      height: 100vh !important;\n      border-radius: 0 !important;\n    }\n\n    .mat-mdc-dialog-surface {\n      padding: 0 !important;\n      margin: 0 !important;\n      max-width: 100vw !important;\n      max-height: 100vh !important;\n      width: 100vw !important;\n      height: 100vh !important;\n      border-radius: 0 !important;\n    }\n\n    .cdk-overlay-pane {\n      max-width: 100vw !important;\n      max-height: 100vh !important;\n      width: 100vw !important;\n      height: 100vh !important;\n      position: fixed !important;\n      top: 0 !important;\n      left: 0 !important;\n    }\n\n    .cdk-overlay-backdrop {\n      background-color: rgba(0, 0, 0, 0.5) !important;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  ::ng-deep .analytics-dialog {\n    .mat-mdc-dialog-container {\n      padding: 0 !important;\n      margin: 0 !important;\n      max-width: 100vw !important;\n      max-height: 100vh !important;\n      width: 100vw !important;\n      height: 100vh !important;\n      border-radius: 0 !important;\n    }\n\n    .mat-mdc-dialog-surface {\n      padding: 0 !important;\n      margin: 0 !important;\n      max-width: 100vw !important;\n      max-height: 100vh !important;\n      width: 100vw !important;\n      height: 100vh !important;\n      border-radius: 0 !important;\n    }\n\n    .cdk-overlay-pane {\n      max-width: 100vw !important;\n      max-height: 100vh !important;\n      width: 100vw !important;\n      height: 100vh !important;\n      position: fixed !important;\n      top: 0 !important;\n      left: 0 !important;\n    }\n  }\n}\n// ==============================================\n// DARK MODE\n// ==============================================\n:host-context(body.theme-dark) {\n  // Fix card/table overlap specific to this page\n  .table-wrap {\n    top: 226px !important;\n  }\n\n  // Page & wrapper backgrounds\n  .dashbored-wrap,\n  .setting-dashboard,\n  .scroll-div,\n  .com-record,\n  .table-wrap,\n  .filter,\n  .search-input,\n  .detail-list,\n  .detail-description {\n    background: #111827 !important;\n    background-color: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n\n  // Tables\n  table, thead, tbody, tr, td {\n    background: #111827 !important;\n    background-color: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n  th {\n    background: #0f172a !important;\n    background-color: #0f172a !important;\n    color: #94a3b8 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n  tbody tr:hover {\n    background: #1f2937 !important;\n    background-color: #1f2937 !important;\n  }\n  tbody tr.no-data-row,\n  tbody tr.no-data-row:hover {\n    background: #111827 !important;\n    background-color: #111827 !important;\n    td { color: #e5e7eb !important; }\n  }\n\n  // Cards / boxes\n  .box {\n    background: #1f2937 !important;\n    background-color: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n    color: #e5e7eb !important;\n  }\n\n  // Text (exclude .view-analytics so it keeps its blue accent)\n  p, span:not(.material-icons):not(.view-analytics), label, li, h1, h2, h3, h4, h5, h6, i, b {\n    color: #e5e7eb !important;\n  }\n\n  // Keep View Analytics link blue + no background in dark mode\n  .view-analytics,\n  td .view-analytics,\n  td span.view-analytics,\n  td .view-analytics *,\n  .mobile-design .view-analytics {\n    color: #5ea1d8 !important;\n    background: transparent !important;\n    background-color: transparent !important;\n    mat-icon { color: #5ea1d8 !important; background: transparent !important; }\n  }\n\n  // Remove background box from inner table rows\n  .inner, .inner tr, .inner td {\n    background: transparent !important;\n    background-color: transparent !important;\n  }\n\n  // Mobile card tiles\n  .mobile-design {\n    background: #0f172a !important;\n    .tile {\n      background: #1f2937 !important;\n      border-color: rgba(148, 163, 184, 0.25) !important;\n      p { color: #94a3b8 !important; }\n    }\n  }\n\n  // Skeleton containers\n  .skeleton-box,\n  .skeleton-tile,\n  .skeleton-table-container,\n  .skeleton-mobile-container {\n    background: #1f2937 !important;\n    background-color: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n    // reset table inside skeleton back to dark\n    table, thead, th, td, tr {\n      background: #1f2937 !important;\n      background-color: #1f2937 !important;\n      border-color: rgba(148, 163, 184, 0.2) !important;\n      color: #4b5563 !important;\n    }\n    thead tr { background-color: #374151 !important; }\n  }\n\n  // Skeleton shimmer elements � dark wave\n  .skeleton-text,\n  .skeleton-bold,\n  .skeleton-count,\n  .skeleton-title,\n  .skeleton-checkbox,\n  .skeleton-icon,\n  .skeleton-image,\n  .skeleton-price,\n  .skeleton-analytics {\n    background: linear-gradient(90deg, #1f2937 25%, #374151 50%, #1f2937 75%) !important;\n    background-size: 200% 100% !important;\n    animation: skeleton-loading 1.5s infinite !important;\n  }\n\n  // No-results state\n  .no-results {\n    background: #1f2937 !important;\n    color: #94a3b8 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n\n  // Collaborated badge – must explicitly override the td color !important\n  .collab-badge {\n    background-color: #1e3a5f !important;\n    color: #93c5fd !important;\n    border-color: #2563eb !important;\n  }\n}\n\n\n// ════════════════════════════════════════════════\n// DARK MODE – direct body.theme-dark rules\n// These compile to body.theme-dark .class[_ngcontent-xxx]\n// which reliably overrides all hardcoded whites.\n// ════════════════════════════════════════════════\nbody.theme-dark .dashbored-wrap,\nbody.theme-dark .setting-dashboard {\n  background: var(--fc-bg) !important;\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .dashbored-wrap .top-menu-wrap,\nbody.theme-dark .dashbored-wrap .box,\nbody.theme-dark .dashbored-wrap .card,\nbody.theme-dark .dashbored-wrap .mat-mdc-card,\nbody.theme-dark .dashbored-wrap .tile,\nbody.theme-dark .dashbored-wrap .com-record,\nbody.theme-dark .dashbored-wrap .table-wrap,\nbody.theme-dark .dashbored-wrap .detail-list,\nbody.theme-dark .dashbored-wrap .filter,\nbody.theme-dark .dashbored-wrap .search-input,\nbody.theme-dark .dashbored-wrap .tab-content,\nbody.theme-dark .dashbored-wrap .followers-tag .box {\n  background: var(--fc-bg2) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap table,\nbody.theme-dark .dashbored-wrap thead,\nbody.theme-dark .dashbored-wrap tbody,\nbody.theme-dark .dashbored-wrap tr,\nbody.theme-dark .dashbored-wrap td {\n  background: var(--fc-bg) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap th {\n  background: var(--fc-bg-head) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap tbody tr:hover {\n  background: var(--fc-bg-hover) !important;\n}\n\nbody.theme-dark .dashbored-wrap input,\nbody.theme-dark .dashbored-wrap select,\nbody.theme-dark .dashbored-wrap textarea {\n  background: #0f172a !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap .mobile-design {\n  background: var(--fc-bg) !important;\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .dashbored-wrap .mobile-design .tile {\n  background: var(--fc-bg2) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap [class*=\"skeleton-\"] {\n  background: var(--fc-skel) !important;\n  color: transparent !important;\n}\n\nbody.theme-dark .dashbored-wrap p,\nbody.theme-dark .dashbored-wrap label,\nbody.theme-dark .dashbored-wrap li,\nbody.theme-dark .dashbored-wrap h1,\nbody.theme-dark .dashbored-wrap h2,\nbody.theme-dark .dashbored-wrap h3,\nbody.theme-dark .dashbored-wrap h4,\nbody.theme-dark .dashbored-wrap h5,\nbody.theme-dark .dashbored-wrap h6 {\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .dashbored-wrap span:not(.material-icons):not(.badge):not([class*=\"status\"]):not(.view-analytics) {\n  color: var(--fc-fg) !important;\n}\n\n/* Keep View Analytics links blue + no background in dark mode */\nbody.theme-dark .dashbored-wrap .view-analytics,\nbody.theme-dark .dashbored-wrap td .view-analytics,\nbody.theme-dark .dashbored-wrap td span.view-analytics,\nbody.theme-dark .dashbored-wrap td .view-analytics * {\n  color: #5ea1d8 !important;\n  background: transparent !important;\n  background-color: transparent !important;\n}\nbody.theme-dark .dashbored-wrap .view-analytics mat-icon {\n  color: #5ea1d8 !important;\n  background: transparent !important;\n}\n\n/* Remove box behind view-analytics row — inner table rows/cells must be transparent */\nbody.theme-dark .dashbored-wrap .inner,\nbody.theme-dark .dashbored-wrap .inner tr,\nbody.theme-dark .dashbored-wrap .inner td {\n  background: transparent !important;\n  background-color: transparent !important;\n}\n/* ── Override global white-background globals (.table-card, .fc-table, .big-box, .filter-section) ── */\nbody.theme-dark .table-card {\n  background: #1f2937 !important;\n  background-color: #1f2937 !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4) !important;\n}\nbody.theme-dark .big-box {\n  background: #111827 !important;\n  background-color: #111827 !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n}\nbody.theme-dark .fc-table {\n  background: #1f2937 !important;\n  background-color: #1f2937 !important;\n}\nbody.theme-dark .fc-table thead th {\n  background-color: #0f172a !important;\n  background: #0f172a !important;\n  color: #94a3b8 !important;\n  border-bottom-color: rgba(148, 163, 184, 0.25) !important;\n  border-right-color: rgba(148, 163, 184, 0.15) !important;\n}\nbody.theme-dark .fc-table tbody td {\n  background-color: #1f2937 !important;\n  color: #e2e8f0 !important;\n  border-top-color: rgba(148, 163, 184, 0.15) !important;\n  border-right-color: rgba(148, 163, 184, 0.1) !important;\n}\nbody.theme-dark .fc-table tbody tr:nth-child(even) td {\n  background-color: #253347 !important;\n}\nbody.theme-dark .fc-table tbody tr:hover td {\n  background-color: #374151 !important;\n  color: #f1f5f9 !important;\n  border-color: rgba(148, 163, 184, 0.3) !important;\n}\nbody.theme-dark .filter-section {\n  background: #1f2937 !important;\n  background-color: #1f2937 !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n}\nbody.theme-dark .filter-section label {\n  color: #94a3b8 !important;\n}\nbody.theme-dark .filter-section select,\nbody.theme-dark .filter-section input {\n  background: #0f172a !important;\n  background-color: #0f172a !important;\n  color: #e2e8f0 !important;\n  border-color: rgba(148, 163, 184, 0.3) !important;\n}\n\n/* ── Dark scrollbars and overflow area fix ── */\nbody.theme-dark .table-parent {\n  background: #1f2937 !important;\n  background-color: #1f2937 !important;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar,\nbody.theme-dark .table-card::-webkit-scrollbar {\n  background: #111827;\n  width: 6px;\n  height: 6px;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-track,\nbody.theme-dark .table-card::-webkit-scrollbar-track {\n  background: #1f2937;\n  border-radius: 4px;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-thumb,\nbody.theme-dark .table-card::-webkit-scrollbar-thumb {\n  background: #374151;\n  border-radius: 4px;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-thumb:hover,\nbody.theme-dark .table-card::-webkit-scrollbar-thumb:hover {\n  background: #4b5563;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-corner,\nbody.theme-dark .table-card::-webkit-scrollbar-corner {\n  background: #111827;\n}\n\n.collab-badge {\n  display: inline-block;\n  margin-left: 8px;\n  padding: 2px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 12px;\n  background-color: #e8f4fd;\n  color: #1565c0;\n  border: 1px solid #90caf9;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
